
const sports = [
  {
    id: "50",
   emoji: "🏠",
    name: "Home",
    path: "/home",
   gridHistory: [
   { gridId: "Prime #1", href: "/prime", emoji: "🏈" },
   
   ], }, {
    id: "1",
    emoji: "🏀",
    name: "NBA",
    path: "/nba",
    gridHistory: [
      { gridId: "NBA #295", href: "/nba/295", emoji: "🏀" },
{ gridId: "NBA #294", href: "/nba/294", emoji: "🏀" },
{ gridId: "NBA #293", href: "/nba/293", emoji: "🏀" },
{ gridId: "NBA #292", href: "/nba/292", emoji: "🏀" },
{ gridId: "NBA #291", href: "/nba/291", emoji: "🏀" },
{ gridId: "NBA #290", href: "/nba/290", emoji: "🏀" },
{ gridId: "NBA #289", href: "/nba/289", emoji: "🏀" },
{ gridId: "NBA #288", href: "/nba/288", emoji: "🏀" },
{ gridId: "NBA #287", href: "/nba/287", emoji: "🏀" },
{ gridId: "NBA #286", href: "/nba/286", emoji: "🏀" },
{ gridId: "NBA #285", href: "/nba/285", emoji: "🏀" },
{ gridId: "NBA #284", href: "/nba/284", emoji: "🏀" },
{ gridId: "NBA #283", href: "/nba/283", emoji: "🏀" },
{ gridId: "NBA #282", href: "/nba/282", emoji: "🏀" },
{ gridId: "NBA #281", href: "/nba/281", emoji: "🏀" },
{ gridId: "NBA #280", href: "/nba/280", emoji: "🏀" },
{ gridId: "NBA #279", href: "/nba/279", emoji: "🏀" },
{ gridId: "NBA #278", href: "/nba/278", emoji: "🏀" },
{ gridId: "NBA #277", href: "/nba/277", emoji: "🏀" },
{ gridId: "NBA #276", href: "/nba/276", emoji: "🏀" },
{ gridId: "NBA #275", href: "/nba/275", emoji: "🏀" },
{ gridId: "NBA #274", href: "/nba/274", emoji: "🏀" },
{ gridId: "NBA #273", href: "/nba/273", emoji: "🏀" },
{ gridId: "NBA #272", href: "/nba/272", emoji: "🏀" },
{ gridId: "NBA #271", href: "/nba/271", emoji: "🏀" },
{ gridId: "NBA #270", href: "/nba/270", emoji: "🏀" },
{ gridId: "NBA #269", href: "/nba/269", emoji: "🏀" },
{ gridId: "NBA #268", href: "/nba/268", emoji: "🏀" },
{ gridId: "NBA #267", href: "/nba/267", emoji: "🏀" },
{ gridId: "NBA #266", href: "/nba/266", emoji: "🏀" },
{ gridId: "NBA #265", href: "/nba/265", emoji: "🏀" },
{ gridId: "NBA #264", href: "/nba/264", emoji: "🏀" },
{ gridId: "NBA #263", href: "/nba/263", emoji: "🏀" },
{ gridId: "NBA #262", href: "/nba/262", emoji: "🏀" },
{ gridId: "NBA #261", href: "/nba/261", emoji: "🏀" },
{ gridId: "NBA #260", href: "/nba/260", emoji: "🏀" },
{ gridId: "NBA #259", href: "/nba/259", emoji: "🏀" },
{ gridId: "NBA #258", href: "/nba/258", emoji: "🏀" },
{ gridId: "NBA #257", href: "/nba/257", emoji: "🏀" },
{ gridId: "NBA #256", href: "/nba/256", emoji: "🏀" },
{ gridId: "NBA #255", href: "/nba/255", emoji: "🏀" },
{ gridId: "NBA #254", href: "/nba/254", emoji: "🏀" },
{ gridId: "NBA #253", href: "/nba/253", emoji: "🏀" },
{ gridId: "NBA #252", href: "/nba/252", emoji: "🏀" },
{ gridId: "NBA #251", href: "/nba/251", emoji: "🏀" },
{ gridId: "NBA #250", href: "/nba/250", emoji: "🏀" },
{ gridId: "NBA #249", href: "/nba/249", emoji: "🏀" },
{ gridId: "NBA #248", href: "/nba/248", emoji: "🏀" },
{ gridId: "NBA #247", href: "/nba/247", emoji: "🏀" },
{ gridId: "NBA #246", href: "/nba/246", emoji: "🏀" },
{ gridId: "NBA #245", href: "/nba/245", emoji: "🏀" },
{ gridId: "NBA #244", href: "/nba/244", emoji: "🏀" },
{ gridId: "NBA #243", href: "/nba/243", emoji: "🏀" },
{ gridId: "NBA #242", href: "/nba/242", emoji: "🏀" },
{ gridId: "NBA #241", href: "/nba/241", emoji: "🏀" },
{ gridId: "NBA #240", href: "/nba/240", emoji: "🏀" },
{ gridId: "NBA #239", href: "/nba/239", emoji: "🏀" },
{ gridId: "NBA #238", href: "/nba/238", emoji: "🏀" },
{ gridId: "NBA #237", href: "/nba/237", emoji: "🏀" },
{ gridId: "NBA #236", href: "/nba/236", emoji: "🏀" },
{ gridId: "NBA #235", href: "/nba/235", emoji: "🏀" },
{ gridId: "NBA #234", href: "/nba/234", emoji: "🏀" },
{ gridId: "NBA #233", href: "/nba/233", emoji: "🏀" },
{ gridId: "NBA #232", href: "/nba/232", emoji: "🏀" },
{ gridId: "NBA #231", href: "/nba/231", emoji: "🏀" },
{ gridId: "NBA #230", href: "/nba/230", emoji: "🏀" },
{ gridId: "NBA #229", href: "/nba/229", emoji: "🏀" },
{ gridId: "NBA #228", href: "/nba/228", emoji: "🏀" },
{ gridId: "NBA #227", href: "/nba/227", emoji: "🏀" },
{ gridId: "NBA #226", href: "/nba/226", emoji: "🏀" },
{ gridId: "NBA #225", href: "/nba/225", emoji: "🏀" },
{ gridId: "NBA #224", href: "/nba/224", emoji: "🏀" },
{ gridId: "NBA #223", href: "/nba/223", emoji: "🏀" },
{ gridId: "NBA #222", href: "/nba/222", emoji: "🏀" },
{ gridId: "NBA #221", href: "/nba/221", emoji: "🏀" },
{ gridId: "NBA #220", href: "/nba/220", emoji: "🏀" },
{ gridId: "NBA #219", href: "/nba/219", emoji: "🏀" },
{ gridId: "NBA #218", href: "/nba/218", emoji: "🏀" },
{ gridId: "NBA #217", href: "/nba/217", emoji: "🏀" },
{ gridId: "NBA #216", href: "/nba/216", emoji: "🏀" },
{ gridId: "NBA #215", href: "/nba/215", emoji: "🏀" },
{ gridId: "NBA #214", href: "/nba/214", emoji: "🏀" },
{ gridId: "NBA #213", href: "/nba/213", emoji: "🏀" },
{ gridId: "NBA #212", href: "/nba/212", emoji: "🏀" },
{ gridId: "NBA #211", href: "/nba/211", emoji: "🏀" },
{ gridId: "NBA #210", href: "/nba/210", emoji: "🏀" },
{ gridId: "NBA #209", href: "/nba/209", emoji: "🏀" },
{ gridId: "NBA #208", href: "/nba/208", emoji: "🏀" },
{ gridId: "NBA #207", href: "/nba/207", emoji: "🏀" },
{ gridId: "NBA #206", href: "/nba/206", emoji: "🏀" },
{ gridId: "NBA #205", href: "/nba/205", emoji: "🏀" },
{ gridId: "NBA #204", href: "/nba/204", emoji: "🏀" },
{ gridId: "NBA #203", href: "/nba/203", emoji: "🏀" },
{ gridId: "NBA #202", href: "/nba/202", emoji: "🏀" },
{ gridId: "NBA #201", href: "/nba/201", emoji: "🏀" },
{ gridId: "NBA #200", href: "/nba/200", emoji: "🏀" },
{ gridId: "NBA #199", href: "/nba/199", emoji: "🏀" },
{ gridId: "NBA #198", href: "/nba/198", emoji: "🏀" },
{ gridId: "NBA #197", href: "/nba/197", emoji: "🏀" },
{ gridId: "NBA #196", href: "/nba/196", emoji: "🏀" },
{ gridId: "NBA #195", href: "/nba/195", emoji: "🏀" },
{ gridId: "NBA #194", href: "/nba/194", emoji: "🏀" },
{ gridId: "NBA #193", href: "/nba/193", emoji: "🏀" },
{ gridId: "NBA #192", href: "/nba/192", emoji: "🏀" },
{ gridId: "NBA #191", href: "/nba/191", emoji: "🏀" },
{ gridId: "NBA #190", href: "/nba/190", emoji: "🏀" },
{ gridId: "NBA #189", href: "/nba/189", emoji: "🏀" },
{ gridId: "NBA #188", href: "/nba/188", emoji: "🏀" },
{ gridId: "NBA #187", href: "/nba/187", emoji: "🏀" },
{ gridId: "NBA #186", href: "/nba/186", emoji: "🏀" },
{ gridId: "NBA #185", href: "/nba/185", emoji: "🏀" },
{ gridId: "NBA #184", href: "/nba/184", emoji: "🏀" },
{ gridId: "NBA #183", href: "/nba/183", emoji: "🏀" },
{ gridId: "NBA #182", href: "/nba/182", emoji: "🏀" },
{ gridId: "NBA #181", href: "/nba/181", emoji: "🏀" },
{ gridId: "NBA #180", href: "/nba/180", emoji: "🏀" },
{ gridId: "NBA #179", href: "/nba/179", emoji: "🏀" },
{ gridId: "NBA #178", href: "/nba/178", emoji: "🏀" },
{ gridId: "NBA #177", href: "/nba/177", emoji: "🏀" },
{ gridId: "NBA #176", href: "/nba/176", emoji: "🏀" },
{ gridId: "NBA #175", href: "/nba/175", emoji: "🏀" },
{ gridId: "NBA #174", href: "/nba/174", emoji: "🏀" },
{ gridId: "NBA #173", href: "/nba/173", emoji: "🏀" },
{ gridId: "NBA #172", href: "/nba/172", emoji: "🏀" },
{ gridId: "NBA #171", href: "/nba/171", emoji: "🏀" },
{ gridId: "NBA #170", href: "/nba/170", emoji: "🏀" },
{ gridId: "NBA #169", href: "/nba/169", emoji: "🏀" },
{ gridId: "NBA #168", href: "/nba/168", emoji: "🏀" },
{ gridId: "NBA #167", href: "/nba/167", emoji: "🏀" },
{ gridId: "NBA #166", href: "/nba/166", emoji: "🏀" },
{ gridId: "NBA #165", href: "/nba/165", emoji: "🏀" },
{ gridId: "NBA #164", href: "/nba/164", emoji: "🏀" },
{ gridId: "NBA #163", href: "/nba/163", emoji: "🏀" },
{ gridId: "NBA #162", href: "/nba/162", emoji: "🏀" },
{ gridId: "NBA #161", href: "/nba/161", emoji: "🏀" },
{ gridId: "NBA #160", href: "/nba/160", emoji: "🏀" },
{ gridId: "NBA #159", href: "/nba/159", emoji: "🏀" },
{ gridId: "NBA #158", href: "/nba/158", emoji: "🏀" },
{ gridId: "NBA #157", href: "/nba/157", emoji: "🏀" },
{ gridId: "NBA #156", href: "/nba/156", emoji: "🏀" },
{ gridId: "NBA #155", href: "/nba/155", emoji: "🏀" },
{ gridId: "NBA #154", href: "/nba/154", emoji: "🏀" },
{ gridId: "NBA #153", href: "/nba/153", emoji: "🏀" },
      { gridId: "NBA #152", href: "/nba/152", emoji: "🏀" },
      { gridId: "NBA #151", href: "/nba/151", emoji: "🏀" },
      { gridId: "NBA #150", href: "/nba/150", emoji: "🏀" },
      { gridId: "NBA #149", href: "/nba/149", emoji: "🏀" },
      { gridId: "NBA #148", href: "/nba/148", emoji: "🏀" },
      { gridId: "NBA #147", href: "/nba/147", emoji: "🏀" },
      { gridId: "NBA #146", href: "/nba/146", emoji: "🏀" },
      { gridId: "NBA #145", href: "/nba/145", emoji: "🏀" },
      { gridId: "NBA #144", href: "/nba/144", emoji: "🏀" },
      { gridId: "NBA #143", href: "/nba/143", emoji: "🏀" },
      { gridId: "NBA #142", href: "/nba/142", emoji: "🏀" },
      { gridId: "NBA #141", href: "/nba/141", emoji: "🏀" },
      { gridId: "NBA #140", href: "/nba/140", emoji: "🏀" },
      { gridId: "NBA #139", href: "/nba/139", emoji: "🏀" },
      { gridId: "NBA #138", href: "/nba/138", emoji: "🏀" },
      { gridId: "NBA #137", href: "/nba/137", emoji: "🏀" },
      { gridId: "NBA #136", href: "/nba/136", emoji: "🏀" },
      { gridId: "NBA #135", href: "/nba/135", emoji: "🏀" },
      { gridId: "NBA #134", href: "/nba/134", emoji: "🏀" },
      { gridId: "NBA #133", href: "/nba/133", emoji: "🏀" },
      { gridId: "NBA #132", href: "/nba/132", emoji: "🏀" },
      { gridId: "NBA #131", href: "/nba/131", emoji: "🏀" },
      { gridId: "NBA #130", href: "/nba/130", emoji: "🏀" },
      { gridId: "NBA #129", href: "/nba/129", emoji: "🏀" },
      { gridId: "NBA #128", href: "/nba/128", emoji: "🏀" },
      { gridId: "NBA #127", href: "/nba/127", emoji: "🏀" },
      { gridId: "NBA #126", href: "/nba/126", emoji: "🏀" },
      { gridId: "NBA #125", href: "/nba/125", emoji: "🏀" },
      { gridId: "NBA #124", href: "/nba/124", emoji: "🏀" },
      { gridId: "NBA #123", href: "/nba/123", emoji: "🏀" },
      { gridId: "NBA #122", href: "/nba/122", emoji: "🏀" },
      { gridId: "NBA #121", href: "/nba/121", emoji: "🏀" },
      { gridId: "NBA #120", href: "/nba/120", emoji: "🏀" },
      { gridId: "NBA #119", href: "/nba/119", emoji: "🏀" },
      { gridId: "NBA #118", href: "/nba/118", emoji: "🏀" },
      { gridId: "NBA #117", href: "/nba/117", emoji: "🏀" },
      { gridId: "NBA #116", href: "/nba/116", emoji: "🏀" },
      { gridId: "NBA #115", href: "/nba/115", emoji: "🏀" },
      { gridId: "NBA #114", href: "/nba/114", emoji: "🏀" },
      { gridId: "NBA #113", href: "/nba/113", emoji: "🏀" },
      { gridId: "NBA #112", href: "/nba/112", emoji: "🏀" },
      { gridId: "NBA #111", href: "/nba/111", emoji: "🏀" },
      { gridId: "NBA #110", href: "/nba/110", emoji: "🏀" },
      { gridId: "NBA #109", href: "/nba/109", emoji: "🏀" },
      { gridId: "NBA #108", href: "/nba/108", emoji: "🏀" },
      { gridId: "NBA #107", href: "/nba/107", emoji: "🏀" },
      { gridId: "NBA #106", href: "/nba/106", emoji: "🏀" },
      { gridId: "NBA #105", href: "/nba/105", emoji: "🏀" },
      { gridId: "NBA #104", href: "/nba/104", emoji: "🏀" },

      { gridId: "NBA #103", href: "/nba/103", emoji: "🏀" },
      { gridId: "NBA #102", href: "/nba/102", emoji: "🏀" },
      { gridId: "NBA #101", href: "/nba/101", emoji: "🏀" },
      { gridId: "NBA #100", href: "/nba/100", emoji: "🏀" },
      { gridId: "NBA #99", href: "/nba/99", emoji: "🏀" },
      { gridId: "NBA #98", href: "/nba/98", emoji: "🏀" },

      { gridId: "NBA #97", href: "/nba/97", emoji: "🏀" },

      { gridId: "NBA #96", href: "/nba/96", emoji: "🏀" },

      { gridId: "NBA #95", href: "/nba/95", emoji: "🏀" },

      { gridId: "NBA #94", href: "/nba/94", emoji: "🏀" },

      { gridId: "NBA #93", href: "/nba/93", emoji: "🏀" },

      { gridId: "NBA #92", href: "/nba/92", emoji: "🏀" },

      { gridId: "NBA #91", href: "/nba/91", emoji: "🏀" },

      { gridId: "NBA #90", href: "/nba/90", emoji: "🏀" },

      { gridId: "NBA #89", href: "/nba/89", emoji: "🏀" },
      { gridId: "NBA #88", href: "/nba/88", emoji: "🏀" },
      { gridId: "NBA #87", href: "/nba/87", emoji: "🏀" },
      { gridId: "NBA #86", href: "/nba/86", emoji: "🏀" },
      { gridId: "NBA #85", href: "/nba/85", emoji: "🏀" },
      { gridId: "NBA #84", href: "/nba/84", emoji: "🏀" },
      { gridId: "NBA #83", href: "/nba/83", emoji: "🏀" },

      { gridId: "NBA #82", href: "/nba/82", emoji: "🏀" },

      { gridId: "NBA #81", href: "/nba/81", emoji: "🏀" },

      { gridId: "NBA #80", href: "/nba/80", emoji: "🏀" },

      { gridId: "NBA #79", href: "/nba/79", emoji: "🏀" },

      { gridId: "NBA #78", href: "/nba/78", emoji: "🏀" },

      { gridId: "NBA #77", href: "/nba/77", emoji: "🏀" },

      { gridId: "NBA #76", href: "/nba/76", emoji: "🏀" },

      { gridId: "NBA #75", href: "/nba/75", emoji: "🏀" },

      { gridId: "NBA #74", href: "/nba/74", emoji: "🏀" },
      { gridId: "NBA #73", href: "/nba/73", emoji: "🏀" },
      { gridId: "NBA #72", href: "/nba/72", emoji: "🏀" },
      { gridId: "NBA #71", href: "/nba/71", emoji: "🏀" },
      { gridId: "NBA #70", href: "/nba/70", emoji: "🏀" },
      { gridId: "NBA #69", href: "/nba/69", emoji: "🏀" },
      { gridId: "NBA #68", href: "/nba/68", emoji: "🏀" },
      { gridId: "NBA #67", href: "/nba/67", emoji: "🏀" },
      { gridId: "NBA #66", href: "/nba/66", emoji: "🏀" },
      { gridId: "NBA #65", href: "/nba/65", emoji: "🏀" },
      { gridId: "NBA #64", href: "/nba/64", emoji: "🏀" },
      { gridId: "NBA #63", href: "/nba/63", emoji: "🏀" },
      { gridId: "NBA #62", href: "/nba/62", emoji: "🏀" },
      { gridId: "NBA #61", href: "/nba/61", emoji: "🏀" },
      { gridId: "NBA #60", href: "/nba/60", emoji: "🏀" },
      { gridId: "NBA #59", href: "/nba/59", emoji: "🏀" },
      { gridId: "NBA #58", href: "/nba/58", emoji: "🏀" },
      { gridId: "NBA #57", href: "/nba/57", emoji: "🏀" },
      { gridId: "NBA #56", href: "/nba/56", emoji: "🏀" },
      { gridId: "NBA #55", href: "/nba/55", emoji: "🏀" },
      { gridId: "NBA #54", href: "/nba/54", emoji: "🏀" },
      { gridId: "NBA #53", href: "/nba/53", emoji: "🏀" },
      { gridId: "NBA #52", href: "/nba/52", emoji: "🏀" },
      { gridId: "NBA #51", href: "/nba/51", emoji: "🏀" },
      { gridId: "NBA #50", href: "/nba/50", emoji: "🏀" },
      { gridId: "NBA #49", href: "/nba/49", emoji: "🏀" },
      { gridId: "NBA #48", href: "/nba/48", emoji: "🏀" },
      { gridId: "NBA #47", href: "/nba/47", emoji: "🏀" },
      { gridId: "NBA #46", href: "/nba/46", emoji: "🏀" },
      { gridId: "NBA #45", href: "/nba/45", emoji: "🏀" },
      { gridId: "NBA #44", href: "/nba/44", emoji: "🏀" },
      { gridId: "NBA #43", href: "/nba/43", emoji: "🏀" },
      { gridId: "NBA #42", href: "/nba/42", emoji: "🏀" },
      { gridId: "NBA #41", href: "/nba/41", emoji: "🏀" },
      { gridId: "NBA #40", href: "/nba/40", emoji: "🏀" },
      { gridId: "NBA #39", href: "/nba/39", emoji: "🏀" },
      { gridId: "NBA #38", href: "/nba/38", emoji: "🏀" },
      { gridId: "NBA #37", href: "/nba/37", emoji: "🏀" },
      { gridId: "NBA #36", href: "/nba/36", emoji: "🏀" },
      { gridId: "NBA #35", href: "/nba/35", emoji: "🏀" },
      { gridId: "NBA #34", href: "/nba/34", emoji: "🏀" },
      { gridId: "NBA #21", href: "/nba/21", emoji: "🏀" },
      { gridId: "NBA #20", href: "/nba/20", emoji: "🏀" },
      { gridId: "NBA #19", href: "/nba/19", emoji: "🏀" },
      { gridId: "NBA #18", href: "/nba/18", emoji: "🏀" },
      { gridId: "NBA #15", href: "/nba/15", emoji: "🏀" },
      { gridId: "NBA #8", href: "/nba/8", emoji: "🏀" },
      { gridId: "NBA #7", href: "/nba/7", emoji: "🏀" },
      { gridId: "NBA #6", href: "/nba/6", emoji: "🏀" },
      { gridId: "NBA #5", href: "/nba/5", emoji: "🏀" },
      { gridId: "NBA #4", href: "/nba/4", emoji: "🏀" },
      { gridId: "NBA #3", href: "/nba/3", emoji: "🏀" },
      { gridId: "NBA #2", href: "/nba/2", emoji: "🏀" },
      { gridId: "NBA #1", href: "/nba/1", emoji: "🏀" },
    ],
  },
  {
    id: "7",
    emoji: "🏈",
    name: "NFL",
    path: "/nfl",
    gridHistory: [
      { gridId: "NFL #274", href: "/nfl/274", emoji: "🏈" },
{ gridId: "NFL #273", href: "/nfl/273", emoji: "🏈" },
{ gridId: "NFL #272", href: "/nfl/272", emoji: "🏈" },
{ gridId: "NFL #271", href: "/nfl/271", emoji: "🏈" },
{ gridId: "NFL #270", href: "/nfl/270", emoji: "🏈" },
{ gridId: "NFL #269", href: "/nfl/269", emoji: "🏈" },
{ gridId: "NFL #268", href: "/nfl/268", emoji: "🏈" },
{ gridId: "NFL #267", href: "/nfl/267", emoji: "🏈" },
{ gridId: "NFL #266", href: "/nfl/266", emoji: "🏈" },
{ gridId: "NFL #265", href: "/nfl/265", emoji: "🏈" },
{ gridId: "NFL #264", href: "/nfl/264", emoji: "🏈" },
{ gridId: "NFL #263", href: "/nfl/263", emoji: "🏈" },
{ gridId: "NFL #262", href: "/nfl/262", emoji: "🏈" },
{ gridId: "NFL #261", href: "/nfl/261", emoji: "🏈" },
{ gridId: "NFL #260", href: "/nfl/260", emoji: "🏈" },
{ gridId: "NFL #259", href: "/nfl/259", emoji: "🏈" },
{ gridId: "NFL #258", href: "/nfl/258", emoji: "🏈" },
{ gridId: "NFL #257", href: "/nfl/257", emoji: "🏈" },
{ gridId: "NFL #256", href: "/nfl/256", emoji: "🏈" },
{ gridId: "NFL #255", href: "/nfl/255", emoji: "🏈" },
{ gridId: "NFL #254", href: "/nfl/254", emoji: "🏈" },
{ gridId: "NFL #253", href: "/nfl/253", emoji: "🏈" },
{ gridId: "NFL #252", href: "/nfl/252", emoji: "🏈" },
{ gridId: "NFL #251", href: "/nfl/251", emoji: "🏈" },
{ gridId: "NFL #250", href: "/nfl/250", emoji: "🏈" },
{ gridId: "NFL #249", href: "/nfl/249", emoji: "🏈" },
{ gridId: "NFL #248", href: "/nfl/248", emoji: "🏈" },
{ gridId: "NFL #247", href: "/nfl/247", emoji: "🏈" },
{ gridId: "NFL #246", href: "/nfl/246", emoji: "🏈" },
{ gridId: "NFL #245", href: "/nfl/245", emoji: "🏈" },
{ gridId: "NFL #244", href: "/nfl/244", emoji: "🏈" },
{ gridId: "NFL #243", href: "/nfl/243", emoji: "🏈" },
{ gridId: "NFL #242", href: "/nfl/242", emoji: "🏈" },
{ gridId: "NFL #241", href: "/nfl/241", emoji: "🏈" },
{ gridId: "NFL #240", href: "/nfl/240", emoji: "🏈" },
{ gridId: "NFL #239", href: "/nfl/239", emoji: "🏈" },
{ gridId: "NFL #238", href: "/nfl/238", emoji: "🏈" },
{ gridId: "NFL #237", href: "/nfl/237", emoji: "🏈" },
{ gridId: "NFL #236", href: "/nfl/236", emoji: "🏈" },
{ gridId: "NFL #235", href: "/nfl/235", emoji: "🏈" },
{ gridId: "NFL #234", href: "/nfl/234", emoji: "🏈" },
{ gridId: "NFL #233", href: "/nfl/233", emoji: "🏈" },
{ gridId: "NFL #232", href: "/nfl/232", emoji: "🏈" },
{ gridId: "NFL #231", href: "/nfl/231", emoji: "🏈" },
{ gridId: "NFL #230", href: "/nfl/230", emoji: "🏈" },
{ gridId: "NFL #229", href: "/nfl/229", emoji: "🏈" },
{ gridId: "NFL #228", href: "/nfl/228", emoji: "🏈" },
{ gridId: "NFL #227", href: "/nfl/227", emoji: "🏈" },
{ gridId: "NFL #226", href: "/nfl/226", emoji: "🏈" },
{ gridId: "NFL #225", href: "/nfl/225", emoji: "🏈" },
{ gridId: "NFL #224", href: "/nfl/224", emoji: "🏈" },
{ gridId: "NFL #223", href: "/nfl/223", emoji: "🏈" },
{ gridId: "NFL #222", href: "/nfl/222", emoji: "🏈" },
{ gridId: "NFL #221", href: "/nfl/221", emoji: "🏈" },
{ gridId: "NFL #220", href: "/nfl/220", emoji: "🏈" },
{ gridId: "NFL #219", href: "/nfl/219", emoji: "🏈" },
{ gridId: "NFL #218", href: "/nfl/218", emoji: "🏈" },
{ gridId: "NFL #217", href: "/nfl/217", emoji: "🏈" },
{ gridId: "NFL #216", href: "/nfl/216", emoji: "🏈" },
{ gridId: "NFL #215", href: "/nfl/215", emoji: "🏈" },
{ gridId: "NFL #214", href: "/nfl/214", emoji: "🏈" },
{ gridId: "NFL #213", href: "/nfl/213", emoji: "🏈" },
{ gridId: "NFL #212", href: "/nfl/212", emoji: "🏈" },
{ gridId: "NFL #211", href: "/nfl/211", emoji: "🏈" },
{ gridId: "NFL #210", href: "/nfl/210", emoji: "🏈" },
{ gridId: "NFL #209", href: "/nfl/209", emoji: "🏈" },
{ gridId: "NFL #208", href: "/nfl/208", emoji: "🏈" },
{ gridId: "NFL #207", href: "/nfl/207", emoji: "🏈" },
{ gridId: "NFL #206", href: "/nfl/206", emoji: "🏈" },
{ gridId: "NFL #205", href: "/nfl/205", emoji: "🏈" },
{ gridId: "NFL #204", href: "/nfl/204", emoji: "🏈" },
{ gridId: "NFL #203", href: "/nfl/203", emoji: "🏈" },
{ gridId: "NFL #202", href: "/nfl/202", emoji: "🏈" },
{ gridId: "NFL #201", href: "/nfl/201", emoji: "🏈" },
{ gridId: "NFL #200", href: "/nfl/200", emoji: "🏈" },
{ gridId: "NFL #199", href: "/nfl/199", emoji: "🏈" },
{ gridId: "NFL #198", href: "/nfl/198", emoji: "🏈" },
{ gridId: "NFL #197", href: "/nfl/197", emoji: "🏈" },
{ gridId: "NFL #196", href: "/nfl/196", emoji: "🏈" },
{ gridId: "NFL #195", href: "/nfl/195", emoji: "🏈" },
{ gridId: "NFL #194", href: "/nfl/194", emoji: "🏈" },
{ gridId: "NFL #193", href: "/nfl/193", emoji: "🏈" },
{ gridId: "NFL #192", href: "/nfl/192", emoji: "🏈" },
{ gridId: "NFL #191", href: "/nfl/191", emoji: "🏈" },
{ gridId: "NFL #190", href: "/nfl/190", emoji: "🏈" },
{ gridId: "NFL #189", href: "/nfl/189", emoji: "🏈" },
{ gridId: "NFL #188", href: "/nfl/188", emoji: "🏈" },
{ gridId: "NFL #187", href: "/nfl/187", emoji: "🏈" },
{ gridId: "NFL #186", href: "/nfl/186", emoji: "🏈" },
{ gridId: "NFL #185", href: "/nfl/185", emoji: "🏈" },
{ gridId: "NFL #184", href: "/nfl/184", emoji: "🏈" },
{ gridId: "NFL #183", href: "/nfl/183", emoji: "🏈" },
{ gridId: "NFL #182", href: "/nfl/182", emoji: "🏈" },
{ gridId: "NFL #181", href: "/nfl/181", emoji: "🏈" },
{ gridId: "NFL #180", href: "/nfl/180", emoji: "🏈" },
{ gridId: "NFL #179", href: "/nfl/179", emoji: "🏈" },
{ gridId: "NFL #178", href: "/nfl/178", emoji: "🏈" },
{ gridId: "NFL #177", href: "/nfl/177", emoji: "🏈" },
{ gridId: "NFL #176", href: "/nfl/176", emoji: "🏈" },
{ gridId: "NFL #175", href: "/nfl/175", emoji: "🏈" },
{ gridId: "NFL #174", href: "/nfl/174", emoji: "🏈" },
{ gridId: "NFL #173", href: "/nfl/173", emoji: "🏈" },
{ gridId: "NFL #172", href: "/nfl/172", emoji: "🏈" },
{ gridId: "NFL #171", href: "/nfl/171", emoji: "🏈" },
{ gridId: "NFL #170", href: "/nfl/170", emoji: "🏈" },
{ gridId: "NFL #169", href: "/nfl/169", emoji: "🏈" },
{ gridId: "NFL #168", href: "/nfl/168", emoji: "🏈" },
{ gridId: "NFL #167", href: "/nfl/167", emoji: "🏈" },
{ gridId: "NFL #166", href: "/nfl/166", emoji: "🏈" },
{ gridId: "NFL #165", href: "/nfl/165", emoji: "🏈" },
{ gridId: "NFL #164", href: "/nfl/164", emoji: "🏈" },
{ gridId: "NFL #163", href: "/nfl/163", emoji: "🏈" },
{ gridId: "NFL #162", href: "/nfl/162", emoji: "🏈" },
{ gridId: "NFL #161", href: "/nfl/161", emoji: "🏈" },
{ gridId: "NFL #160", href: "/nfl/160", emoji: "🏈" },
{ gridId: "NFL #159", href: "/nfl/159", emoji: "🏈" },
{ gridId: "NFL #158", href: "/nfl/158", emoji: "🏈" },
{ gridId: "NFL #157", href: "/nfl/157", emoji: "🏈" },
{ gridId: "NFL #156", href: "/nfl/156", emoji: "🏈" },
{ gridId: "NFL #155", href: "/nfl/155", emoji: "🏈" },
{ gridId: "NFL #154", href: "/nfl/154", emoji: "🏈" },
{ gridId: "NFL #153", href: "/nfl/153", emoji: "🏈" },
{ gridId: "NFL #152", href: "/nfl/152", emoji: "🏈" },
{ gridId: "NFL #151", href: "/nfl/151", emoji: "🏈" },
{ gridId: "NFL #150", href: "/nfl/150", emoji: "🏈" },
{ gridId: "NFL #149", href: "/nfl/149", emoji: "🏈" },
{ gridId: "NFL #148", href: "/nfl/148", emoji: "🏈" },
{ gridId: "NFL #147", href: "/nfl/147", emoji: "🏈" },
{ gridId: "NFL #146", href: "/nfl/146", emoji: "🏈" },
{ gridId: "NFL #145", href: "/nfl/145", emoji: "🏈" },
{ gridId: "NFL #144", href: "/nfl/144", emoji: "🏈" },
{ gridId: "NFL #143", href: "/nfl/143", emoji: "🏈" },
      { gridId: "NFL: #142", href: "/nfl/142", emoji: "🏈" },
      { gridId: "NFL: #141", href: "/nfl/141", emoji: "🏈" },
      { gridId: "NFL: #140", href: "/nfl/140", emoji: "🏈" },
      { gridId: "NFL: #139", href: "/nfl/139", emoji: "🏈" },
      { gridId: "NFL: #138", href: "/nfl/138", emoji: "🏈" },
      { gridId: "NFL: #137", href: "/nfl/137", emoji: "🏈" },
      { gridId: "NFL: #136", href: "/nfl/136", emoji: "🏈" },
      { gridId: "NFL: #135", href: "/nfl/135", emoji: "🏈" },
      { gridId: "NFL: #134", href: "/nfl/134", emoji: "🏈" },
      { gridId: "NFL: #133", href: "/nfl/133", emoji: "🏈" },
      { gridId: "NFL: #132", href: "/nfl/132", emoji: "🏈" },
      { gridId: "NFL: #131", href: "/nfl/131", emoji: "🏈" },
      { gridId: "NFL: #130", href: "/nfl/130", emoji: "🏈" },
      { gridId: "NFL: #129", href: "/nfl/129", emoji: "🏈" },
      { gridId: "NFL: #128", href: "/nfl/128", emoji: "🏈" },
      { gridId: "NFL: #127", href: "/nfl/127", emoji: "🏈" },
      { gridId: "NFL: #126", href: "/nfl/126", emoji: "🏈" },
      { gridId: "NFL: #125", href: "/nfl/125", emoji: "🏈" },
      { gridId: "NFL: #124", href: "/nfl/124", emoji: "🏈" },
      { gridId: "NFL: #123", href: "/nfl/123", emoji: "🏈" },
      { gridId: "NFL: #122", href: "/nfl/122", emoji: "🏈" },
      { gridId: "NFL: #121", href: "/nfl/121", emoji: "🏈" },
      { gridId: "NFL: #120", href: "/nfl/120", emoji: "🏈" },
      { gridId: "NFL: #119", href: "/nfl/119", emoji: "🏈" },
      { gridId: "NFL: #118", href: "/nfl/118", emoji: "🏈" },
      { gridId: "NFL: #117", href: "/nfl/117", emoji: "🏈" },
      { gridId: "NFL: #116", href: "/nfl/116", emoji: "🏈" },
      { gridId: "NFL: #115", href: "/nfl/115", emoji: "🏈" },
      { gridId: "NFL: #114", href: "/nfl/114", emoji: "🏈" },
      { gridId: "NFL: #113", href: "/nfl/113", emoji: "🏈" },
      { gridId: "NFL #112", href: "/nfl/112", emoji: "🏈" },
      { gridId: "NFL #111", href: "/nfl/111", emoji: "🏈" },
      { gridId: "NFL #110", href: "/nfl/110", emoji: "🏈" },
      { gridId: "NFL #109", href: "/nfl/109", emoji: "🏈" },
      { gridId: "NFL #108", href: "/nfl/108", emoji: "🏈" },
      { gridId: "NFL #107", href: "/nfl/107", emoji: "🏈" },
      { gridId: "NFL #106", href: "/nfl/106", emoji: "🏈" },
      { gridId: "NFL #105", href: "/nfl/105", emoji: "🏈" },
      { gridId: "NFL #104", href: "/nfl/104", emoji: "🏈" },
      { gridId: "NFL #103", href: "/nfl/103", emoji: "🏈" },
      { gridId: "NFL #102", href: "/nfl/102", emoji: "🏈" },
      { gridId: "NFL #101", href: "/nfl/101", emoji: "🏈" },
      { gridId: "NFL #100", href: "/nfl/100", emoji: "🏈" },
      { gridId: "NFL #99", href: "/nfl/99", emoji: "🏈" },
      { gridId: "NFL #98", href: "/nfl/98", emoji: "🏈" },

      { gridId: "NFL #97", href: "/nfl/97", emoji: "🏈" },
      { gridId: "NFL #96", href: "/nfl/96", emoji: "🏈" },
      { gridId: "NFL #95", href: "/nfl/95", emoji: "🏈" },
      { gridId: "NFL #94", href: "/nfl/94", emoji: "🏈" },

      { gridId: "NFL #93", href: "/nfl/93", emoji: "🏈" },
      { gridId: "NFL #92", href: "/nfl/92", emoji: "🏈" },
      { gridId: "NFL #91", href: "/nfl/91", emoji: "🏈" },
      { gridId: "NFL #90", href: "/nfl/90", emoji: "🏈" },
      { gridId: "NFL #89", href: "/nfl/89", emoji: "🏈" },
      { gridId: "NFL #88", href: "/nfl/88", emoji: "🏈" },
      { gridId: "NFL #87", href: "/nfl/87", emoji: "🏈" },
      { gridId: "NFL #86", href: "/nfl/86", emoji: "🏈" },

      { gridId: "NFL #85", href: "/nfl/85", emoji: "🏈" },
      { gridId: "NFL #84", href: "/nfl/84", emoji: "🏈" },
      { gridId: "NFL #83", href: "/nfl/83", emoji: "🏈" },
      { gridId: "NFL #82", href: "/nfl/82", emoji: "🏈" },
      { gridId: "NFL #81", href: "/nfl/81", emoji: "🏈" },
      { gridId: "NFL #80", href: "/nfl/80", emoji: "🏈" },
      { gridId: "NFL #79", href: "/nfl/79", emoji: "🏈" },

      { gridId: "NFL #78", href: "/nfl/78", emoji: "🏈" },

      { gridId: "NFL #77", href: "/nfl/77", emoji: "🏈" },

      { gridId: "NFL #76", href: "/nfl/76", emoji: "🏈" },

      { gridId: "NFL #75", href: "/nfl/75", emoji: "🏈" },
      { gridId: "NFL #74", href: "/nfl/74", emoji: "🏈" },

      { gridId: "NFL #73", href: "/nfl/73", emoji: "🏈" },

      { gridId: "NFL #72", href: "/nfl/72", emoji: "🏈" },

      { gridId: "NFL #71", href: "/nfl/71", emoji: "🏈" },

      { gridId: "NFL #70", href: "/nfl/70", emoji: "🏈" },
      { gridId: "NFL #69", href: "/nfl/69", emoji: "🏈" },
      { gridId: "NFL #68", href: "/nfl/68", emoji: "🏈" },
      { gridId: "NFL #67", href: "/nfl/67", emoji: "🏈" },
      { gridId: "NFL #66", href: "/nfl/66", emoji: "🏈" },
      { gridId: "NFL #65", href: "/nfl/65", emoji: "🏈" },
      { gridId: "NFL #64", href: "/nfl/64", emoji: "🏈" },
      { gridId: "NFL #63", href: "/nfl/63", emoji: "🏈" },
      { gridId: "NFL #62", href: "/nfl/62", emoji: "🏈" },
      { gridId: "NFL #61", href: "/nfl/61", emoji: "🏈" },
      { gridId: "NFL #60", href: "/nfl/60", emoji: "🏈" },
      { gridId: "NFL #59", href: "/nfl/59", emoji: "🏈" },
      { gridId: "NFL #58", href: "/nfl/58", emoji: "🏈" },
      { gridId: "NFL #57", href: "/nfl/57", emoji: "🏈" },
      { gridId: "NFL #56", href: "/nfl/56", emoji: "🏈" },
      { gridId: "NFL #55", href: "/nfl/55", emoji: "🏈" },
      { gridId: "NFL #54", href: "/nfl/54", emoji: "🏈" },
      { gridId: "NFL #53", href: "/nfl/53", emoji: "🏈" },
      { gridId: "NFL #52", href: "/nfl/52", emoji: "🏈" },
      { gridId: "NFL #51", href: "/nfl/51", emoji: "🏈" },
      { gridId: "NFL #50", href: "/nfl/50", emoji: "🏈" },
      { gridId: "NFL #49", href: "/nfl/49", emoji: "🏈" },
      { gridId: "NFL #48", href: "/nfl/48", emoji: "🏈" },
      { gridId: "NFL #47", href: "/nfl/47", emoji: "🏈" },
      { gridId: "NFL #46", href: "/nfl/46", emoji: "🏈" },
      { gridId: "NFL #45", href: "/nfl/45", emoji: "🏈" },
    ],
  },
  {
    id: "12",
    emoji: "🎬🍿",
    name: "Movies",
    path: "/movies",
    gridHistory: [], // Will be populated dynamically from start date through today
    fetchDynamicHistory: true, // Flag to indicate dynamic date-based fetching
    sportIdForAPI: 12, // Sport ID for the new /game/sport/{id}/date endpoint
  },
  {
    id: "14",
    emoji: "🤼",
    name: "WWE",
    path: "/wrestling",
    gridHistory: [], // Will be populated dynamically from yesterday through Dec 2025
    fetchDynamicHistory: true, // Flag to indicate dynamic date-based fetching
    sportIdForAPI: 14, // Sport ID for the new /game/sport/{id}/date endpoint
  },
  {
    id: "21",
   emoji: "🏀🧠",
    name: "Trivia",
    path: "/daily-exclusive",
   gridHistory: [
   { gridId: "Prime #1", href: "/prime", emoji: "🏈" },

   ],
   },  {
    id: "58",
    emoji: "👾",
    name: "Multiplayer",
    path: "/play",
    gridHistory: [

      { gridId: "TV #1", href: "/tv/1", emoji: "📺" },
      // ... other grid history data
    ],
  },
  {
    id: "25",
    emoji: "🎬🍿",
    name: "MovieQuest",
    path: "/unlimited",
    gridHistory: [

      { gridId: "TV #1", href: "/tv/1", emoji: "📺" },
      // ... other grid history data
    ],
  },

  

  {
    id: "3",
    emoji: "🏒",
    name: "NHL",
    path: "/nhl",
    gridHistory: [
      { gridId: "NHL #274", href: "/nhl/274", emoji: "🏒" },
{ gridId: "NHL #273", href: "/nhl/273", emoji: "🏒" },
{ gridId: "NHL #272", href: "/nhl/272", emoji: "🏒" },
{ gridId: "NHL #271", href: "/nhl/271", emoji: "🏒" },
{ gridId: "NHL #270", href: "/nhl/270", emoji: "🏒" },
{ gridId: "NHL #269", href: "/nhl/269", emoji: "🏒" },
{ gridId: "NHL #268", href: "/nhl/268", emoji: "🏒" },
{ gridId: "NHL #267", href: "/nhl/267", emoji: "🏒" },
{ gridId: "NHL #266", href: "/nhl/266", emoji: "🏒" },
{ gridId: "NHL #265", href: "/nhl/265", emoji: "🏒" },
{ gridId: "NHL #264", href: "/nhl/264", emoji: "🏒" },
{ gridId: "NHL #263", href: "/nhl/263", emoji: "🏒" },
{ gridId: "NHL #262", href: "/nhl/262", emoji: "🏒" },
{ gridId: "NHL #261", href: "/nhl/261", emoji: "🏒" },
{ gridId: "NHL #260", href: "/nhl/260", emoji: "🏒" },
{ gridId: "NHL #259", href: "/nhl/259", emoji: "🏒" },
{ gridId: "NHL #258", href: "/nhl/258", emoji: "🏒" },
{ gridId: "NHL #257", href: "/nhl/257", emoji: "🏒" },
{ gridId: "NHL #256", href: "/nhl/256", emoji: "🏒" },
{ gridId: "NHL #255", href: "/nhl/255", emoji: "🏒" },
{ gridId: "NHL #254", href: "/nhl/254", emoji: "🏒" },
{ gridId: "NHL #253", href: "/nhl/253", emoji: "🏒" },
{ gridId: "NHL #252", href: "/nhl/252", emoji: "🏒" },
{ gridId: "NHL #251", href: "/nhl/251", emoji: "🏒" },
{ gridId: "NHL #250", href: "/nhl/250", emoji: "🏒" },
{ gridId: "NHL #249", href: "/nhl/249", emoji: "🏒" },
{ gridId: "NHL #248", href: "/nhl/248", emoji: "🏒" },
{ gridId: "NHL #247", href: "/nhl/247", emoji: "🏒" },
{ gridId: "NHL #246", href: "/nhl/246", emoji: "🏒" },
{ gridId: "NHL #245", href: "/nhl/245", emoji: "🏒" },
{ gridId: "NHL #244", href: "/nhl/244", emoji: "🏒" },
{ gridId: "NHL #243", href: "/nhl/243", emoji: "🏒" },
{ gridId: "NHL #242", href: "/nhl/242", emoji: "🏒" },
{ gridId: "NHL #241", href: "/nhl/241", emoji: "🏒" },
{ gridId: "NHL #240", href: "/nhl/240", emoji: "🏒" },
{ gridId: "NHL #239", href: "/nhl/239", emoji: "🏒" },
{ gridId: "NHL #238", href: "/nhl/238", emoji: "🏒" },
{ gridId: "NHL #237", href: "/nhl/237", emoji: "🏒" },
{ gridId: "NHL #236", href: "/nhl/236", emoji: "🏒" },
{ gridId: "NHL #235", href: "/nhl/235", emoji: "🏒" },
{ gridId: "NHL #234", href: "/nhl/234", emoji: "🏒" },
{ gridId: "NHL #233", href: "/nhl/233", emoji: "🏒" },
{ gridId: "NHL #232", href: "/nhl/232", emoji: "🏒" },
{ gridId: "NHL #231", href: "/nhl/231", emoji: "🏒" },
{ gridId: "NHL #230", href: "/nhl/230", emoji: "🏒" },
{ gridId: "NHL #229", href: "/nhl/229", emoji: "🏒" },
{ gridId: "NHL #228", href: "/nhl/228", emoji: "🏒" },
{ gridId: "NHL #227", href: "/nhl/227", emoji: "🏒" },
{ gridId: "NHL #226", href: "/nhl/226", emoji: "🏒" },
{ gridId: "NHL #225", href: "/nhl/225", emoji: "🏒" },
{ gridId: "NHL #224", href: "/nhl/224", emoji: "🏒" },
{ gridId: "NHL #223", href: "/nhl/223", emoji: "🏒" },
{ gridId: "NHL #222", href: "/nhl/222", emoji: "🏒" },
{ gridId: "NHL #221", href: "/nhl/221", emoji: "🏒" },
{ gridId: "NHL #220", href: "/nhl/220", emoji: "🏒" },
{ gridId: "NHL #219", href: "/nhl/219", emoji: "🏒" },
{ gridId: "NHL #218", href: "/nhl/218", emoji: "🏒" },
{ gridId: "NHL #217", href: "/nhl/217", emoji: "🏒" },
{ gridId: "NHL #216", href: "/nhl/216", emoji: "🏒" },
{ gridId: "NHL #215", href: "/nhl/215", emoji: "🏒" },
{ gridId: "NHL #214", href: "/nhl/214", emoji: "🏒" },
{ gridId: "NHL #213", href: "/nhl/213", emoji: "🏒" },
{ gridId: "NHL #212", href: "/nhl/212", emoji: "🏒" },
{ gridId: "NHL #211", href: "/nhl/211", emoji: "🏒" },
{ gridId: "NHL #210", href: "/nhl/210", emoji: "🏒" },
{ gridId: "NHL #209", href: "/nhl/209", emoji: "🏒" },
{ gridId: "NHL #208", href: "/nhl/208", emoji: "🏒" },
{ gridId: "NHL #207", href: "/nhl/207", emoji: "🏒" },
{ gridId: "NHL #206", href: "/nhl/206", emoji: "🏒" },
{ gridId: "NHL #205", href: "/nhl/205", emoji: "🏒" },
{ gridId: "NHL #204", href: "/nhl/204", emoji: "🏒" },
{ gridId: "NHL #203", href: "/nhl/203", emoji: "🏒" },
{ gridId: "NHL #202", href: "/nhl/202", emoji: "🏒" },
{ gridId: "NHL #201", href: "/nhl/201", emoji: "🏒" },
{ gridId: "NHL #200", href: "/nhl/200", emoji: "🏒" },
{ gridId: "NHL #199", href: "/nhl/199", emoji: "🏒" },
{ gridId: "NHL #198", href: "/nhl/198", emoji: "🏒" },
{ gridId: "NHL #197", href: "/nhl/197", emoji: "🏒" },
{ gridId: "NHL #196", href: "/nhl/196", emoji: "🏒" },
{ gridId: "NHL #195", href: "/nhl/195", emoji: "🏒" },
{ gridId: "NHL #194", href: "/nhl/194", emoji: "🏒" },
{ gridId: "NHL #193", href: "/nhl/193", emoji: "🏒" },
{ gridId: "NHL #192", href: "/nhl/192", emoji: "🏒" },
{ gridId: "NHL #191", href: "/nhl/191", emoji: "🏒" },
{ gridId: "NHL #190", href: "/nhl/190", emoji: "🏒" },
{ gridId: "NHL #189", href: "/nhl/189", emoji: "🏒" },
{ gridId: "NHL #188", href: "/nhl/188", emoji: "🏒" },
{ gridId: "NHL #187", href: "/nhl/187", emoji: "🏒" },
{ gridId: "NHL #186", href: "/nhl/186", emoji: "🏒" },
{ gridId: "NHL #185", href: "/nhl/185", emoji: "🏒" },
{ gridId: "NHL #184", href: "/nhl/184", emoji: "🏒" },
{ gridId: "NHL #183", href: "/nhl/183", emoji: "🏒" },
{ gridId: "NHL #182", href: "/nhl/182", emoji: "🏒" },
{ gridId: "NHL #181", href: "/nhl/181", emoji: "🏒" },
{ gridId: "NHL #180", href: "/nhl/180", emoji: "🏒" },
{ gridId: "NHL #179", href: "/nhl/179", emoji: "🏒" },
{ gridId: "NHL #178", href: "/nhl/178", emoji: "🏒" },
{ gridId: "NHL #177", href: "/nhl/177", emoji: "🏒" },
{ gridId: "NHL #176", href: "/nhl/176", emoji: "🏒" },
{ gridId: "NHL #175", href: "/nhl/175", emoji: "🏒" },
{ gridId: "NHL #174", href: "/nhl/174", emoji: "🏒" },
{ gridId: "NHL #173", href: "/nhl/173", emoji: "🏒" },
{ gridId: "NHL #172", href: "/nhl/172", emoji: "🏒" },
{ gridId: "NHL #171", href: "/nhl/171", emoji: "🏒" },
{ gridId: "NHL #170", href: "/nhl/170", emoji: "🏒" },
{ gridId: "NHL #169", href: "/nhl/169", emoji: "🏒" },
{ gridId: "NHL #168", href: "/nhl/168", emoji: "🏒" },
{ gridId: "NHL #167", href: "/nhl/167", emoji: "🏒" },
{ gridId: "NHL #166", href: "/nhl/166", emoji: "🏒" },
{ gridId: "NHL #165", href: "/nhl/165", emoji: "🏒" },
{ gridId: "NHL #164", href: "/nhl/164", emoji: "🏒" },
{ gridId: "NHL #163", href: "/nhl/163", emoji: "🏒" },
{ gridId: "NHL #162", href: "/nhl/162", emoji: "🏒" },
{ gridId: "NHL #161", href: "/nhl/161", emoji: "🏒" },
{ gridId: "NHL #160", href: "/nhl/160", emoji: "🏒" },
{ gridId: "NHL #159", href: "/nhl/159", emoji: "🏒" },
{ gridId: "NHL #158", href: "/nhl/158", emoji: "🏒" },
{ gridId: "NHL #157", href: "/nhl/157", emoji: "🏒" },
{ gridId: "NHL #156", href: "/nhl/156", emoji: "🏒" },
{ gridId: "NHL #155", href: "/nhl/155", emoji: "🏒" },
{ gridId: "NHL #154", href: "/nhl/154", emoji: "🏒" },
{ gridId: "NHL #153", href: "/nhl/153", emoji: "🏒" },
{ gridId: "NHL #152", href: "/nhl/152", emoji: "🏒" },
{ gridId: "NHL #151", href: "/nhl/151", emoji: "🏒" },
{ gridId: "NHL #150", href: "/nhl/150", emoji: "🏒" },
{ gridId: "NHL #149", href: "/nhl/149", emoji: "🏒" },
{ gridId: "NHL #148", href: "/nhl/148", emoji: "🏒" },
{ gridId: "NHL #147", href: "/nhl/147", emoji: "🏒" },
{ gridId: "NHL #146", href: "/nhl/146", emoji: "🏒" },
{ gridId: "NHL #145", href: "/nhl/145", emoji: "🏒" },
{ gridId: "NHL #144", href: "/nhl/144", emoji: "🏒" },
{ gridId: "NHL #143", href: "/nhl/143", emoji: "🏒" },
{ gridId: "NHL #142", href: "/nhl/142", emoji: "🏒" },
{ gridId: "NHL #141", href: "/nhl/141", emoji: "🏒" },
{ gridId: "NHL #140", href: "/nhl/140", emoji: "🏒" },
{ gridId: "NHL #139", href: "/nhl/139", emoji: "🏒" },
{ gridId: "NHL #138", href: "/nhl/138", emoji: "🏒" },
{ gridId: "NHL #137", href: "/nhl/137", emoji: "🏒" },
{ gridId: "NHL #136", href: "/nhl/136", emoji: "🏒" },
{ gridId: "NHL #135", href: "/nhl/135", emoji: "🏒" },
{ gridId: "NHL #134", href: "/nhl/134", emoji: "🏒" },
{ gridId: "NHL #133", href: "/nhl/133", emoji: "🏒" },
      { gridId: "NHL: #132", href: "/nhl/132", emoji: "🏒" },
      { gridId: "NHL: #131", href: "/nhl/131", emoji: "🏒" },
      { gridId: "NHL: #130", href: "/nhl/130", emoji: "🏒" },
      { gridId: "NHL: #129", href: "/nhl/129", emoji: "🏒" },
      { gridId: "NHL: #128", href: "/nhl/128", emoji: "🏒" },
      { gridId: "NHL: #127", href: "/nhl/127", emoji: "🏒" },
      { gridId: "NHL: #126", href: "/nhl/126", emoji: "🏒" },
      { gridId: "NHL: #125", href: "/nhl/125", emoji: "🏒" },
      { gridId: "NHL: #124", href: "/nhl/124", emoji: "🏒" },
      { gridId: "NHL: #123", href: "/nhl/123", emoji: "🏒" },
      { gridId: "NHL: #122", href: "/nhl/122", emoji: "🏒" },
      { gridId: "NHL: #121", href: "/nhl/121", emoji: "🏒" },
      { gridId: "NHL: #120", href: "/nhl/120", emoji: "🏒" },
      { gridId: "NHL: #119", href: "/nhl/119", emoji: "🏒" },
      { gridId: "NHL: #118", href: "/nhl/118", emoji: "🏒" },
      { gridId: "NHL: #117", href: "/nhl/117", emoji: "🏒" },
      { gridId: "NHL: #116", href: "/nhl/116", emoji: "🏒" },
      { gridId: "NHL: #115", href: "/nhl/115", emoji: "🏒" },
      { gridId: "NHL: #114", href: "/nhl/114", emoji: "🏒" },
      { gridId: "NHL: #113", href: "/nhl/113", emoji: "🏒" },
      { gridId: "NHL: #112", href: "/nhl/112", emoji: "🏒" },
      { gridId: "NHL: #111", href: "/nhl/111", emoji: "🏒" },
      { gridId: "NHL: #110", href: "/nhl/110", emoji: "🏒" },
      { gridId: "NHL: #109", href: "/nhl/109", emoji: "🏒" },
      { gridId: "NHL: #108", href: "/nhl/108", emoji: "🏒" },
      { gridId: "NHL: #107", href: "/nhl/107", emoji: "🏒" },
      { gridId: "NHL: #106", href: "/nhl/106", emoji: "🏒" },
      { gridId: "NHL: #105", href: "/nhl/105", emoji: "🏒" },
      { gridId: "NHL: #104", href: "/nhl/104", emoji: "🏒" },
      { gridId: "NHL: #103", href: "/nhl/103", emoji: "🏒" },
      { gridId: "NHL: #102", href: "/nhl/102", emoji: "🏒" },
      { gridId: "NHL: #101", href: "/nhl/101", emoji: "🏒" },
      { gridId: "NHL: #100", href: "/nhl/100", emoji: "🏒" },
      { gridId: "NHL: #99", href: "/nhl/99", emoji: "🏒" },
      { gridId: "NHL: #98", href: "/nhl/98", emoji: "🏒" },
      { gridId: "NHL: #97", href: "/nhl/97", emoji: "🏒" },
      { gridId: "NHL: #96", href: "/nhl/96", emoji: "🏒" },
      { gridId: "NHL #95", href: "/nhl/95", emoji: "🏒" },
      { gridId: "NHL #94", href: "/nhl/94", emoji: "🏒" },
      { gridId: "NHL #93", href: "/nhl/93", emoji: "🏒" },
      { gridId: "NHL #92", href: "/nhl/92", emoji: "🏒" },
      { gridId: "NHL #91", href: "/nhl/91", emoji: "🏒" },
      { gridId: "NHL #90", href: "/nhl/90", emoji: "🏒" },
      { gridId: "NHL #89", href: "/nhl/89", emoji: "🏒" },
      { gridId: "NHL #88", href: "/nhl/88", emoji: "🏒" },
      { gridId: "NHL #87", href: "/nhl/87", emoji: "🏒" },
      { gridId: "NHL #86", href: "/nhl/86", emoji: "🏒" },
      { gridId: "NHL #85", href: "/nhl/85", emoji: "🏒" },

      { gridId: "NHL #84", href: "/nhl/84", emoji: "🏒" },
      { gridId: "NHL #83", href: "/nhl/83", emoji: "🏒" },
      { gridId: "NHL #82", href: "/nhl/82", emoji: "🏒" },
      { gridId: "NHL #81", href: "/nhl/81", emoji: "🏒" },
      { gridId: "NHL #80", href: "/nhl/80", emoji: "🏒" },
      { gridId: "NHL #79", href: "/nhl/79", emoji: "🏒" },

      { gridId: "NHL #78", href: "/nhl/78", emoji: "🏒" },
      { gridId: "NHL #77", href: "/nhl/77", emoji: "🏒" },
      { gridId: "NHL #76", href: "/nhl/76", emoji: "🏒" },
      { gridId: "NHL #75", href: "/nhl/75", emoji: "🏒" },
      { gridId: "NHL #74", href: "/nhl/74", emoji: "🏒" },
      { gridId: "NHL #73", href: "/nhl/73", emoji: "🏒" },
      { gridId: "NHL #72", href: "/nhl/72", emoji: "🏒" },
      { gridId: "NHL #71", href: "/nhl/71", emoji: "🏒" },
      { gridId: "NHL #70", href: "/nhl/70", emoji: "🏒" },
      { gridId: "NHL #69", href: "/nhl/69", emoji: "🏒" },
      { gridId: "NHL #68", href: "/nhl/68", emoji: "🏒" },
      { gridId: "NHL #67", href: "/nhl/67", emoji: "🏒" },
      { gridId: "NHL #66", href: "/nhl/66", emoji: "🏒" },

      { gridId: "NHL #65", href: "/nhl/65", emoji: "🏒" },

      { gridId: "NHL #64", href: "/nhl/64", emoji: "🏒" },

      { gridId: "NHL #63", href: "/nhl/63", emoji: "🏒" },

      { gridId: "NHL #62", href: "/nhl/62", emoji: "🏒" },

      { gridId: "NHL #61", href: "/nhl/61", emoji: "🏒" },

      { gridId: "NHL #60", href: "/nhl/60", emoji: "🏒" },

      { gridId: "NHL #59", href: "/nhl/59", emoji: "🏒" },

      { gridId: "NHL #58", href: "/nhl/58", emoji: "🏒" },

      { gridId: "NHL #57", href: "/nhl/57", emoji: "🏒" },
      { gridId: "NHL #56", href: "/nhl/56", emoji: "🏒" },
      // ... other grid history data
      { gridId: "NHL #55", href: "/nhl/55", emoji: "🏒" },
      { gridId: "NHL #54", href: "/nhl/54", emoji: "🏒" },
      { gridId: "NHL #53", href: "/nhl/53", emoji: "🏒" },
      { gridId: "NHL #52", href: "/nhl/52", emoji: "🏒" },
      { gridId: "NHL #51", href: "/nhl/51", emoji: "🏒" },
      { gridId: "NHL #50", href: "/nhl/50", emoji: "🏒" },
      { gridId: "NHL Bonus", href: "/mitts", emoji: "🏒" },

      { gridId: "NHL #49", href: "/nhl/49", emoji: "🏒" },
      { gridId: "NHL #48", href: "/nhl/48", emoji: "🏒" },
      { gridId: "NHL #47", href: "/nhl/47", emoji: "🏒" },
      { gridId: "NHL #46", href: "/nhl/46", emoji: "🏒" },
      { gridId: "NHL #45", href: "/nhl/45", emoji: "🏒" },
      { gridId: "NHL #44", href: "/nhl/44", emoji: "🏒" },
      { gridId: "NHL #43", href: "/nhl/43", emoji: "🏒" },
      { gridId: "NHL #42", href: "/nhl/42", emoji: "🏒" },
      { gridId: "NHL #41", href: "/nhl/41", emoji: "🏒" },
      { gridId: "NHL #40", href: "/nhl/40", emoji: "🏒" },
      { gridId: "NHL #39", href: "/nhl/39", emoji: "🏒" },
      { gridId: "NHL #38", href: "/nhl/38", emoji: "🏒" },
      { gridId: "NHL #37", href: "/nhl/37", emoji: "🏒" },
      { gridId: "NHL #36", href: "/nhl/36", emoji: "🏒" },
      { gridId: "NHL #35", href: "/nhl/35", emoji: "🏒" },
      { gridId: "NHL #34", href: "/nhl/34", emoji: "🏒" },
      { gridId: "NHL #33", href: "/nhl/33", emoji: "🏒" },
      { gridId: "NHL #32", href: "/nhl/32", emoji: "🏒" },
      { gridId: "NHL #31", href: "/nhl/31", emoji: "🏒" },
      { gridId: "NHL #30", href: "/nhl/30", emoji: "🏒" },
      { gridId: "NHL #29", href: "/nhl/29", emoji: "🏒" },
      { gridId: "NHL #28", href: "/nhl/28", emoji: "🏒" },
      { gridId: "NHL #27", href: "/nhl/27", emoji: "🏒" },
      { gridId: "NHL #26", href: "/nhl/26", emoji: "🏒" },
      { gridId: "NHL #25", href: "/nhl/25", emoji: "🏒" },
      { gridId: "NHL #24", href: "/nhl/24", emoji: "🏒" },
      { gridId: "NHL #23", href: "/nhl/23", emoji: "🏒" },
      { gridId: "NHL #22", href: "/nhl/22", emoji: "🏒" },
    ],
  },
  {
    id: "8",
    emoji: "⚽️",
    name: "FC",
    path: "/soccer",
    gridHistory: [

{ gridId: "Soccer #249", href: "/soccer/249", emoji: "⚽️" },
{ gridId: "Soccer #248", href: "/soccer/248", emoji: "⚽️" },
{ gridId: "Soccer #247", href: "/soccer/247", emoji: "⚽️" },
{ gridId: "Soccer #246", href: "/soccer/246", emoji: "⚽️" },
{ gridId: "Soccer #245", href: "/soccer/245", emoji: "⚽️" },
{ gridId: "Soccer #244", href: "/soccer/244", emoji: "⚽️" },
{ gridId: "Soccer #243", href: "/soccer/243", emoji: "⚽️" },
{ gridId: "Soccer #242", href: "/soccer/242", emoji: "⚽️" },
{ gridId: "Soccer #241", href: "/soccer/241", emoji: "⚽️" },
{ gridId: "Soccer #240", href: "/soccer/240", emoji: "⚽️" },
{ gridId: "Soccer #239", href: "/soccer/239", emoji: "⚽️" },
{ gridId: "Soccer #238", href: "/soccer/238", emoji: "⚽️" },
{ gridId: "Soccer #237", href: "/soccer/237", emoji: "⚽️" },
{ gridId: "Soccer #236", href: "/soccer/236", emoji: "⚽️" },
{ gridId: "Soccer #235", href: "/soccer/235", emoji: "⚽️" },
{ gridId: "Soccer #234", href: "/soccer/234", emoji: "⚽️" },
{ gridId: "Soccer #233", href: "/soccer/233", emoji: "⚽️" },
{ gridId: "Soccer #232", href: "/soccer/232", emoji: "⚽️" },
{ gridId: "Soccer #231", href: "/soccer/231", emoji: "⚽️" },
{ gridId: "Soccer #230", href: "/soccer/230", emoji: "⚽️" },
{ gridId: "Soccer #229", href: "/soccer/229", emoji: "⚽️" },
{ gridId: "Soccer #228", href: "/soccer/228", emoji: "⚽️" },
{ gridId: "Soccer #227", href: "/soccer/227", emoji: "⚽️" },
{ gridId: "Soccer #226", href: "/soccer/226", emoji: "⚽️" },
{ gridId: "Soccer #225", href: "/soccer/225", emoji: "⚽️" },
{ gridId: "Soccer #224", href: "/soccer/224", emoji: "⚽️" },
{ gridId: "Soccer #223", href: "/soccer/223", emoji: "⚽️" },
{ gridId: "Soccer #222", href: "/soccer/222", emoji: "⚽️" },
{ gridId: "Soccer #221", href: "/soccer/221", emoji: "⚽️" },
{ gridId: "Soccer #220", href: "/soccer/220", emoji: "⚽️" },
{ gridId: "Soccer #219", href: "/soccer/219", emoji: "⚽️" },
{ gridId: "Soccer #218", href: "/soccer/218", emoji: "⚽️" },
{ gridId: "Soccer #217", href: "/soccer/217", emoji: "⚽️" },
{ gridId: "Soccer #216", href: "/soccer/216", emoji: "⚽️" },
{ gridId: "Soccer #215", href: "/soccer/215", emoji: "⚽️" },
{ gridId: "Soccer #214", href: "/soccer/214", emoji: "⚽️" },
{ gridId: "Soccer #213", href: "/soccer/213", emoji: "⚽️" },
{ gridId: "Soccer #212", href: "/soccer/212", emoji: "⚽️" },
{ gridId: "Soccer #211", href: "/soccer/211", emoji: "⚽️" },
{ gridId: "Soccer #210", href: "/soccer/210", emoji: "⚽️" },
{ gridId: "Soccer #209", href: "/soccer/209", emoji: "⚽️" },
{ gridId: "Soccer #208", href: "/soccer/208", emoji: "⚽️" },
{ gridId: "Soccer #207", href: "/soccer/207", emoji: "⚽️" },
{ gridId: "Soccer #206", href: "/soccer/206", emoji: "⚽️" },
{ gridId: "Soccer #205", href: "/soccer/205", emoji: "⚽️" },
{ gridId: "Soccer #204", href: "/soccer/204", emoji: "⚽️" },
{ gridId: "Soccer #203", href: "/soccer/203", emoji: "⚽️" },
{ gridId: "Soccer #202", href: "/soccer/202", emoji: "⚽️" },
{ gridId: "Soccer #201", href: "/soccer/201", emoji: "⚽️" },
{ gridId: "Soccer #200", href: "/soccer/200", emoji: "⚽️" },
{ gridId: "Soccer #199", href: "/soccer/199", emoji: "⚽️" },
{ gridId: "Soccer #198", href: "/soccer/198", emoji: "⚽️" },
{ gridId: "Soccer #197", href: "/soccer/197", emoji: "⚽️" },
{ gridId: "Soccer #196", href: "/soccer/196", emoji: "⚽️" },
{ gridId: "Soccer #195", href: "/soccer/195", emoji: "⚽️" },
{ gridId: "Soccer #194", href: "/soccer/194", emoji: "⚽️" },
{ gridId: "Soccer #193", href: "/soccer/193", emoji: "⚽️" },
{ gridId: "Soccer #192", href: "/soccer/192", emoji: "⚽️" },
{ gridId: "Soccer #191", href: "/soccer/191", emoji: "⚽️" },
{ gridId: "Soccer #190", href: "/soccer/190", emoji: "⚽️" },
{ gridId: "Soccer #189", href: "/soccer/189", emoji: "⚽️" },
{ gridId: "Soccer #188", href: "/soccer/188", emoji: "⚽️" },
{ gridId: "Soccer #187", href: "/soccer/187", emoji: "⚽️" },
{ gridId: "Soccer #186", href: "/soccer/186", emoji: "⚽️" },
{ gridId: "Soccer #185", href: "/soccer/185", emoji: "⚽️" },
{ gridId: "Soccer #184", href: "/soccer/184", emoji: "⚽️" },
{ gridId: "Soccer #183", href: "/soccer/183", emoji: "⚽️" },
{ gridId: "Soccer #182", href: "/soccer/182", emoji: "⚽️" },
{ gridId: "Soccer #181", href: "/soccer/181", emoji: "⚽️" },
{ gridId: "Soccer #180", href: "/soccer/180", emoji: "⚽️" },
{ gridId: "Soccer #179", href: "/soccer/179", emoji: "⚽️" },
{ gridId: "Soccer #178", href: "/soccer/178", emoji: "⚽️" },
{ gridId: "Soccer #177", href: "/soccer/177", emoji: "⚽️" },
{ gridId: "Soccer #176", href: "/soccer/176", emoji: "⚽️" },
{ gridId: "Soccer #175", href: "/soccer/175", emoji: "⚽️" },
{ gridId: "Soccer #174", href: "/soccer/174", emoji: "⚽️" },
{ gridId: "Soccer #173", href: "/soccer/173", emoji: "⚽️" },
{ gridId: "Soccer #172", href: "/soccer/172", emoji: "⚽️" },
{ gridId: "Soccer #171", href: "/soccer/171", emoji: "⚽️" },
{ gridId: "Soccer #170", href: "/soccer/170", emoji: "⚽️" },
{ gridId: "Soccer #169", href: "/soccer/169", emoji: "⚽️" },
{ gridId: "Soccer #168", href: "/soccer/168", emoji: "⚽️" },
{ gridId: "Soccer #167", href: "/soccer/167", emoji: "⚽️" },
{ gridId: "Soccer #166", href: "/soccer/166", emoji: "⚽️" },
{ gridId: "Soccer #165", href: "/soccer/165", emoji: "⚽️" },
{ gridId: "Soccer #164", href: "/soccer/164", emoji: "⚽️" },
{ gridId: "Soccer #163", href: "/soccer/163", emoji: "⚽️" },
{ gridId: "Soccer #162", href: "/soccer/162", emoji: "⚽️" },
{ gridId: "Soccer #161", href: "/soccer/161", emoji: "⚽️" },
{ gridId: "Soccer #160", href: "/soccer/160", emoji: "⚽️" },
{ gridId: "Soccer #159", href: "/soccer/159", emoji: "⚽️" },
{ gridId: "Soccer #158", href: "/soccer/158", emoji: "⚽️" },
{ gridId: "Soccer #157", href: "/soccer/157", emoji: "⚽️" },
{ gridId: "Soccer #156", href: "/soccer/156", emoji: "⚽️" },
{ gridId: "Soccer #155", href: "/soccer/155", emoji: "⚽️" },
{ gridId: "Soccer #154", href: "/soccer/154", emoji: "⚽️" },
{ gridId: "Soccer #153", href: "/soccer/153", emoji: "⚽️" },
{ gridId: "Soccer #152", href: "/soccer/152", emoji: "⚽️" },
{ gridId: "Soccer #151", href: "/soccer/151", emoji: "⚽️" },
{ gridId: "Soccer #150", href: "/soccer/150", emoji: "⚽️" },
{ gridId: "Soccer #149", href: "/soccer/149", emoji: "⚽️" },
{ gridId: "Soccer #148", href: "/soccer/148", emoji: "⚽️" },
{ gridId: "Soccer #147", href: "/soccer/147", emoji: "⚽️" },
{ gridId: "Soccer #146", href: "/soccer/146", emoji: "⚽️" },
{ gridId: "Soccer #145", href: "/soccer/145", emoji: "⚽️" },
{ gridId: "Soccer #144", href: "/soccer/144", emoji: "⚽️" },
{ gridId: "Soccer #143", href: "/soccer/143", emoji: "⚽️" },
{ gridId: "Soccer #142", href: "/soccer/142", emoji: "⚽️" },
{ gridId: "Soccer #141", href: "/soccer/141", emoji: "⚽️" },
{ gridId: "Soccer #140", href: "/soccer/140", emoji: "⚽️" },
{ gridId: "Soccer #139", href: "/soccer/139", emoji: "⚽️" },
{ gridId: "Soccer #138", href: "/soccer/138", emoji: "⚽️" },
{ gridId: "Soccer #137", href: "/soccer/137", emoji: "⚽️" },
{ gridId: "Soccer #136", href: "/soccer/136", emoji: "⚽️" },
{ gridId: "Soccer #135", href: "/soccer/135", emoji: "⚽️" },
{ gridId: "Soccer #134", href: "/soccer/134", emoji: "⚽️" },
{ gridId: "Soccer #133", href: "/soccer/133", emoji: "⚽️" },
{ gridId: "Soccer #132", href: "/soccer/132", emoji: "⚽️" },
{ gridId: "Soccer #131", href: "/soccer/131", emoji: "⚽️" },
{ gridId: "Soccer #130", href: "/soccer/130", emoji: "⚽️" },
{ gridId: "Soccer #129", href: "/soccer/129", emoji: "⚽️" },
{ gridId: "Soccer #128", href: "/soccer/128", emoji: "⚽️" },
{ gridId: "Soccer #127", href: "/soccer/127", emoji: "⚽️" },
{ gridId: "Soccer #126", href: "/soccer/126", emoji: "⚽️" },
      { gridId: "Soccer: #125", href: "/soccer/125", emoji: "⚽️" },
      { gridId: "Soccer: #124", href: "/soccer/124", emoji: "⚽️" },
      { gridId: "Soccer: #123", href: "/soccer/123", emoji: "⚽️" },
      { gridId: "Soccer: #122", href: "/soccer/122", emoji: "⚽️" },
      { gridId: "Soccer: #121", href: "/soccer/121", emoji: "⚽️" },
      { gridId: "Soccer: #120", href: "/soccer/120", emoji: "⚽️" },
      { gridId: "Soccer: #119", href: "/soccer/119", emoji: "⚽️" },
      { gridId: "Soccer: #118", href: "/soccer/118", emoji: "⚽️" },
      { gridId: "Soccer: #117", href: "/soccer/117", emoji: "⚽️" },
      { gridId: "Soccer: #116", href: "/soccer/116", emoji: "⚽️" },
      { gridId: "Soccer: #115", href: "/soccer/115", emoji: "⚽️" },
      { gridId: "Soccer: #114", href: "/soccer/114", emoji: "⚽️" },
      { gridId: "Soccer: #113", href: "/soccer/113", emoji: "⚽️" },
      { gridId: "Soccer: #112", href: "/soccer/112", emoji: "⚽️" },
      { gridId: "Soccer: #111", href: "/soccer/111", emoji: "⚽️" },
      { gridId: "Soccer: #110", href: "/soccer/110", emoji: "⚽️" },
      { gridId: "Soccer: #109", href: "/soccer/109", emoji: "⚽️" },
      { gridId: "Soccer: #108", href: "/soccer/108", emoji: "⚽️" },
      { gridId: "Soccer: #107", href: "/soccer/107", emoji: "⚽️" },
      { gridId: "Soccer: #106", href: "/soccer/106", emoji: "⚽️" },
      { gridId: "Soccer: #105", href: "/soccer/105", emoji: "⚽️" },
      { gridId: "Soccer: #104", href: "/soccer/104", emoji: "⚽️" },
      { gridId: "Soccer: #103", href: "/soccer/103", emoji: "⚽️" },
      { gridId: "Soccer: #102", href: "/soccer/102", emoji: "⚽️" },
      { gridId: "Soccer: #101", href: "/soccer/101", emoji: "⚽️" },
      { gridId: "Soccer: #100", href: "/soccer/100", emoji: "⚽️" },
      { gridId: "Soccer: #99", href: "/soccer/99", emoji: "⚽️" },
      { gridId: "Soccer: #98", href: "/soccer/98", emoji: "⚽️" },
      { gridId: "Soccer: #97", href: "/soccer/97", emoji: "⚽️" },
      { gridId: "Soccer: #96", href: "/soccer/96", emoji: "⚽️" },
      { gridId: "Soccer: #95", href: "/soccer/95", emoji: "⚽️" },
      { gridId: "Soccer: #94", href: "/soccer/94", emoji: "⚽️" },
      { gridId: "Soccer: #93", href: "/soccer/93", emoji: "⚽️" },
      { gridId: "Soccer: #92", href: "/soccer/92", emoji: "⚽️" },
      { gridId: "Soccer: #91", href: "/soccer/91", emoji: "⚽️" },
      { gridId: "Soccer: #90", href: "/soccer/90", emoji: "⚽️" },
      { gridId: "FC #89", href: "/soccer/89", emoji: "⚽️" },
      { gridId: "FC #88", href: "/soccer/88", emoji: "⚽️" },
      { gridId: "FC #87", href: "/soccer/87", emoji: "⚽️" },
      { gridId: "FC #86", href: "/soccer/86", emoji: "⚽️" },
      { gridId: "FC #85", href: "/soccer/85", emoji: "⚽️" },
      { gridId: "FC #84", href: "/soccer/84", emoji: "⚽️" },
      { gridId: "FC #83", href: "/soccer/83", emoji: "⚽️" },
      { gridId: "FC #82", href: "/soccer/82", emoji: "⚽️" },
      { gridId: "FC #81", href: "/soccer/81", emoji: "⚽️" },
      { gridId: "FC #80", href: "/soccer/80", emoji: "⚽️" },
      { gridId: "FC #79", href: "/soccer/79", emoji: "⚽️" },
      { gridId: "FC #78", href: "/soccer/78", emoji: "⚽️" },
      { gridId: "FC #77", href: "/soccer/77", emoji: "⚽️" },
      { gridId: "FC #76", href: "/soccer/76", emoji: "⚽️" },
      { gridId: "FC #75", href: "/soccer/75", emoji: "⚽️" },

      { gridId: "FC #74", href: "/soccer/74", emoji: "⚽️" },
      { gridId: "FC #73", href: "/soccer/73", emoji: "⚽️" },
      { gridId: "FC #72", href: "/soccer/72", emoji: "⚽️" },
      { gridId: "FC #71", href: "/soccer/71", emoji: "⚽️" },
      { gridId: "FC #70", href: "/soccer/70", emoji: "⚽️" },

      { gridId: "FC #69", href: "/soccer/69", emoji: "⚽️" },
      { gridId: "FC #68", href: "/soccer/68", emoji: "⚽️" },
      { gridId: "FC #67", href: "/soccer/67", emoji: "⚽️" },
      { gridId: "FC #66", href: "/soccer/66", emoji: "⚽️" },
      { gridId: "FC #65", href: "/soccer/65", emoji: "⚽️" },
      { gridId: "FC #64", href: "/soccer/64", emoji: "⚽️" },

      { gridId: "FC #63", href: "/soccer/63", emoji: "⚽️" },
      { gridId: "FC #62", href: "/soccer/62", emoji: "⚽️" },
      { gridId: "FC #61", href: "/soccer/61", emoji: "⚽️" },
      { gridId: "FC #60", href: "/soccer/60", emoji: "⚽️" },
      { gridId: "FC #59", href: "/soccer/59", emoji: "⚽️" },
      { gridId: "FC #58", href: "/soccer/58", emoji: "⚽️" },
      { gridId: "FC #57", href: "/soccer/57", emoji: "⚽️" },
      { gridId: "FC #56", href: "/soccer/56", emoji: "⚽️" },

      { gridId: "FC #55", href: "/soccer/55", emoji: "⚽️" },

      { gridId: "FC #54", href: "/soccer/54", emoji: "⚽️" },

      { gridId: "Bonus #7", href: "/futbol/7", emoji: "⚽️" },
      { gridId: "FC #53", href: "/soccer/53", emoji: "⚽️" },

      { gridId: "Bonus #6", href: "/futbol/6", emoji: "⚽️" },

      { gridId: "FC #52", href: "/soccer/52", emoji: "⚽️" },

      { gridId: "FC #51", href: "/soccer/51", emoji: "⚽️" },

      { gridId: "Bonus #5", href: "/futbol/5", emoji: "⚽️" },

      { gridId: "FC #50", href: "/soccer/50", emoji: "⚽️" },

      { gridId: "FC #49", href: "/soccer/49", emoji: "⚽️" },
      { gridId: "FC #48", href: "/soccer/48", emoji: "⚽️" },
      { gridId: "Bonus #4", href: "/futbol/4", emoji: "⚽️" },
      { gridId: "Sky #1", href: "/futbol/sky", emoji: "⚽️" },
      { gridId: "PL #3", href: "/futbol/3", emoji: "⚽️" },
      { gridId: "PL #2", href: "/futbol/2", emoji: "⚽️" },
      { gridId: "PL #1", href: "/futbol/1", emoji: "⚽️" },
      { gridId: "FC #47", href: "/soccer/47", emoji: "⚽️" },
      { gridId: "FC #46", href: "/soccer/46", emoji: "⚽️" },
      { gridId: "FC #45", href: "/soccer/45", emoji: "⚽️" },
      { gridId: "FC #44", href: "/soccer/44", emoji: "⚽️" },
      { gridId: "FC #43", href: "/soccer/43", emoji: "⚽️" },
      { gridId: "FC #42", href: "/soccer/42", emoji: "⚽️" },
      { gridId: "FC #41", href: "/soccer/41", emoji: "⚽️" },
      { gridId: "FC #40", href: "/soccer/40", emoji: "⚽️" },
      { gridId: "FC #39", href: "/soccer/39", emoji: "⚽️" },
      { gridId: "FC #38", href: "/soccer/38", emoji: "⚽️" },
      { gridId: "FC #37", href: "/soccer/37", emoji: "⚽️" },
      { gridId: "FC #36", href: "/soccer/36", emoji: "⚽️" },
      { gridId: "FC #35", href: "/soccer/35", emoji: "⚽️" },
      { gridId: "FC #34", href: "/soccer/34", emoji: "⚽️" },
      { gridId: "FC #33", href: "/soccer/33", emoji: "⚽️" },
      { gridId: "FC #32", href: "/soccer/32", emoji: "⚽️" },
      { gridId: "FC #31", href: "/soccer/31", emoji: "⚽️" },
      { gridId: "FC #30", href: "/soccer/30", emoji: "⚽️" },
      { gridId: "FC #29", href: "/soccer/29", emoji: "⚽️" },
      { gridId: "FC #28", href: "/soccer/28", emoji: "⚽️" },

      // ... other grid history data
    ],
  },
  {
    id: "5",
    emoji: "⚾️",
    name: "MLB",
    path: "/mlb",
    gridHistory: [
      { gridId: "MLB #211", href: "/mlb/211", emoji: "⚾️" },
{ gridId: "MLB #210", href: "/mlb/210", emoji: "⚾️" },
{ gridId: "MLB #209", href: "/mlb/209", emoji: "⚾️" },
{ gridId: "MLB #208", href: "/mlb/208", emoji: "⚾️" },
{ gridId: "MLB #207", href: "/mlb/207", emoji: "⚾️" },
{ gridId: "MLB #206", href: "/mlb/206", emoji: "⚾️" },
{ gridId: "MLB #205", href: "/mlb/205", emoji: "⚾️" },
{ gridId: "MLB #204", href: "/mlb/204", emoji: "⚾️" },
{ gridId: "MLB #203", href: "/mlb/203", emoji: "⚾️" },
{ gridId: "MLB #202", href: "/mlb/202", emoji: "⚾️" },
{ gridId: "MLB #201", href: "/mlb/201", emoji: "⚾️" },
{ gridId: "MLB #200", href: "/mlb/200", emoji: "⚾️" },
{ gridId: "MLB #199", href: "/mlb/199", emoji: "⚾️" },
{ gridId: "MLB #198", href: "/mlb/198", emoji: "⚾️" },
{ gridId: "MLB #197", href: "/mlb/197", emoji: "⚾️" },
{ gridId: "MLB #196", href: "/mlb/196", emoji: "⚾️" },
{ gridId: "MLB #195", href: "/mlb/195", emoji: "⚾️" },
{ gridId: "MLB #194", href: "/mlb/194", emoji: "⚾️" },
{ gridId: "MLB #193", href: "/mlb/193", emoji: "⚾️" },
{ gridId: "MLB #192", href: "/mlb/192", emoji: "⚾️" },
{ gridId: "MLB #191", href: "/mlb/191", emoji: "⚾️" },
{ gridId: "MLB #190", href: "/mlb/190", emoji: "⚾️" },
{ gridId: "MLB #189", href: "/mlb/189", emoji: "⚾️" },
{ gridId: "MLB #188", href: "/mlb/188", emoji: "⚾️" },
{ gridId: "MLB #187", href: "/mlb/187", emoji: "⚾️" },
{ gridId: "MLB #186", href: "/mlb/186", emoji: "⚾️" },
{ gridId: "MLB #185", href: "/mlb/185", emoji: "⚾️" },
{ gridId: "MLB #184", href: "/mlb/184", emoji: "⚾️" },
{ gridId: "MLB #183", href: "/mlb/183", emoji: "⚾️" },
{ gridId: "MLB #182", href: "/mlb/182", emoji: "⚾️" },
{ gridId: "MLB #181", href: "/mlb/181", emoji: "⚾️" },
{ gridId: "MLB #180", href: "/mlb/180", emoji: "⚾️" },
{ gridId: "MLB #179", href: "/mlb/179", emoji: "⚾️" },
{ gridId: "MLB #178", href: "/mlb/178", emoji: "⚾️" },
{ gridId: "MLB #177", href: "/mlb/177", emoji: "⚾️" },
{ gridId: "MLB #176", href: "/mlb/176", emoji: "⚾️" },
{ gridId: "MLB #175", href: "/mlb/175", emoji: "⚾️" },
{ gridId: "MLB #174", href: "/mlb/174", emoji: "⚾️" },
{ gridId: "MLB #173", href: "/mlb/173", emoji: "⚾️" },
{ gridId: "MLB #172", href: "/mlb/172", emoji: "⚾️" },
{ gridId: "MLB #171", href: "/mlb/171", emoji: "⚾️" },
{ gridId: "MLB #170", href: "/mlb/170", emoji: "⚾️" },
{ gridId: "MLB #169", href: "/mlb/169", emoji: "⚾️" },
{ gridId: "MLB #168", href: "/mlb/168", emoji: "⚾️" },
{ gridId: "MLB #167", href: "/mlb/167", emoji: "⚾️" },
{ gridId: "MLB #166", href: "/mlb/166", emoji: "⚾️" },
{ gridId: "MLB #165", href: "/mlb/165", emoji: "⚾️" },
{ gridId: "MLB #164", href: "/mlb/164", emoji: "⚾️" },
{ gridId: "MLB #163", href: "/mlb/163", emoji: "⚾️" },
{ gridId: "MLB #162", href: "/mlb/162", emoji: "⚾️" },
{ gridId: "MLB #161", href: "/mlb/161", emoji: "⚾️" },
{ gridId: "MLB #160", href: "/mlb/160", emoji: "⚾️" },
{ gridId: "MLB #159", href: "/mlb/159", emoji: "⚾️" },
{ gridId: "MLB #158", href: "/mlb/158", emoji: "⚾️" },
{ gridId: "MLB #157", href: "/mlb/157", emoji: "⚾️" },
{ gridId: "MLB #156", href: "/mlb/156", emoji: "⚾️" },
{ gridId: "MLB #155", href: "/mlb/155", emoji: "⚾️" },
{ gridId: "MLB #154", href: "/mlb/154", emoji: "⚾️" },
{ gridId: "MLB #153", href: "/mlb/153", emoji: "⚾️" },
{ gridId: "MLB #152", href: "/mlb/152", emoji: "⚾️" },
{ gridId: "MLB #151", href: "/mlb/151", emoji: "⚾️" },
{ gridId: "MLB #150", href: "/mlb/150", emoji: "⚾️" },
{ gridId: "MLB #149", href: "/mlb/149", emoji: "⚾️" },
{ gridId: "MLB #148", href: "/mlb/148", emoji: "⚾️" },
{ gridId: "MLB #147", href: "/mlb/147", emoji: "⚾️" },
{ gridId: "MLB #146", href: "/mlb/146", emoji: "⚾️" },
{ gridId: "MLB #145", href: "/mlb/145", emoji: "⚾️" },
{ gridId: "MLB #144", href: "/mlb/144", emoji: "⚾️" },
{ gridId: "MLB #143", href: "/mlb/143", emoji: "⚾️" },
{ gridId: "MLB #142", href: "/mlb/142", emoji: "⚾️" },
{ gridId: "MLB #141", href: "/mlb/141", emoji: "⚾️" },
{ gridId: "MLB #140", href: "/mlb/140", emoji: "⚾️" },
{ gridId: "MLB #139", href: "/mlb/139", emoji: "⚾️" },
{ gridId: "MLB #138", href: "/mlb/138", emoji: "⚾️" },
{ gridId: "MLB #137", href: "/mlb/137", emoji: "⚾️" },
{ gridId: "MLB #136", href: "/mlb/136", emoji: "⚾️" },
{ gridId: "MLB #135", href: "/mlb/135", emoji: "⚾️" },
{ gridId: "MLB #134", href: "/mlb/134", emoji: "⚾️" },
{ gridId: "MLB #133", href: "/mlb/133", emoji: "⚾️" },
{ gridId: "MLB #132", href: "/mlb/132", emoji: "⚾️" },
{ gridId: "MLB #131", href: "/mlb/131", emoji: "⚾️" },
{ gridId: "MLB #130", href: "/mlb/130", emoji: "⚾️" },
{ gridId: "MLB #129", href: "/mlb/129", emoji: "⚾️" },
{ gridId: "MLB #128", href: "/mlb/128", emoji: "⚾️" },
{ gridId: "MLB #127", href: "/mlb/127", emoji: "⚾️" },
{ gridId: "MLB #126", href: "/mlb/126", emoji: "⚾️" },
{ gridId: "MLB #125", href: "/mlb/125", emoji: "⚾️" },
{ gridId: "MLB #124", href: "/mlb/124", emoji: "⚾️" },
{ gridId: "MLB #123", href: "/mlb/123", emoji: "⚾️" },
{ gridId: "MLB #122", href: "/mlb/122", emoji: "⚾️" },
{ gridId: "MLB #121", href: "/mlb/121", emoji: "⚾️" },
{ gridId: "MLB #120", href: "/mlb/120", emoji: "⚾️" },
{ gridId: "MLB #119", href: "/mlb/119", emoji: "⚾️" },
{ gridId: "MLB #118", href: "/mlb/118", emoji: "⚾️" },
{ gridId: "MLB #117", href: "/mlb/117", emoji: "⚾️" },
{ gridId: "MLB #116", href: "/mlb/116", emoji: "⚾️" },
{ gridId: "MLB #115", href: "/mlb/115", emoji: "⚾️" },
{ gridId: "MLB #114", href: "/mlb/114", emoji: "⚾️" },
{ gridId: "MLB #113", href: "/mlb/113", emoji: "⚾️" },
{ gridId: "MLB #112", href: "/mlb/112", emoji: "⚾️" },
{ gridId: "MLB #111", href: "/mlb/111", emoji: "⚾️" },
{ gridId: "MLB #110", href: "/mlb/110", emoji: "⚾️" },
{ gridId: "MLB #109", href: "/mlb/109", emoji: "⚾️" },
{ gridId: "MLB #108", href: "/mlb/108", emoji: "⚾️" },
{ gridId: "MLB #107", href: "/mlb/107", emoji: "⚾️" },
{ gridId: "MLB #106", href: "/mlb/106", emoji: "⚾️" },
{ gridId: "MLB #105", href: "/mlb/105", emoji: "⚾️" },
{ gridId: "MLB #104", href: "/mlb/104", emoji: "⚾️" },
{ gridId: "MLB #103", href: "/mlb/103", emoji: "⚾️" },
{ gridId: "MLB #102", href: "/mlb/102", emoji: "⚾️" },
{ gridId: "MLB #101", href: "/mlb/101", emoji: "⚾️" },
      { gridId: "MLB: #100", href: "/mlb/100", emoji: "⚾️" },
      { gridId: "MLB: #99", href: "/mlb/99", emoji: "⚾️" },
      { gridId: "MLB: #98", href: "/mlb/98", emoji: "⚾️" },
      { gridId: "MLB: #97", href: "/mlb/97", emoji: "⚾️" },
      { gridId: "MLB: #96", href: "/mlb/96", emoji: "⚾️" },
      { gridId: "MLB: #95", href: "/mlb/95", emoji: "⚾️" },
      { gridId: "MLB: #94", href: "/mlb/94", emoji: "⚾️" },
      { gridId: "MLB: #93", href: "/mlb/93", emoji: "⚾️" },
      { gridId: "MLB: #92", href: "/mlb/92", emoji: "⚾️" },
      { gridId: "MLB: #91", href: "/mlb/91", emoji: "⚾️" },
      { gridId: "MLB: #90", href: "/mlb/90", emoji: "⚾️" },
      { gridId: "MLB: #89", href: "/mlb/89", emoji: "⚾️" },
      { gridId: "MLB: #88", href: "/mlb/88", emoji: "⚾️" },
      { gridId: "MLB: #87", href: "/mlb/87", emoji: "⚾️" },
      { gridId: "MLB: #86", href: "/mlb/86", emoji: "⚾️" },
      { gridId: "MLB: #85", href: "/mlb/85", emoji: "⚾️" },
      { gridId: "MLB: #84", href: "/mlb/84", emoji: "⚾️" },
      { gridId: "MLB: #83", href: "/mlb/83", emoji: "⚾️" },
      { gridId: "MLB: #82", href: "/mlb/82", emoji: "⚾️" },
      { gridId: "MLB: #81", href: "/mlb/81", emoji: "⚾️" },
      { gridId: "MLB: #80", href: "/mlb/80", emoji: "⚾️" },
      { gridId: "MLB: #79", href: "/mlb/79", emoji: "⚾️" },
      { gridId: "MLB: #78", href: "/mlb/78", emoji: "⚾️" },
      { gridId: "MLB: #77", href: "/mlb/77", emoji: "⚾️" },
      { gridId: "MLB: #76", href: "/mlb/76", emoji: "⚾️" },
      { gridId: "MLB: #75", href: "/mlb/75", emoji: "⚾️" },
      { gridId: "MLB: #74", href: "/mlb/74", emoji: "⚾️" },
      { gridId: "MLB: #73", href: "/mlb/73", emoji: "⚾️" },
      { gridId: "MLB: #72", href: "/mlb/72", emoji: "⚾️" },
      { gridId: "MLB #71", href: "/mlb/71", emoji: "⚾️" },
      { gridId: "MLB #70", href: "/mlb/70", emoji: "⚾️" },
      { gridId: "MLB #69", href: "/mlb/69", emoji: "⚾️" },
      { gridId: "MLB #68", href: "/mlb/68", emoji: "⚾️" },
      { gridId: "MLB #67", href: "/mlb/67", emoji: "⚾️" },
      { gridId: "MLB #66", href: "/mlb/66", emoji: "⚾️" },
      { gridId: "MLB #65", href: "/mlb/65", emoji: "⚾️" },
      { gridId: "MLB #64", href: "/mlb/64", emoji: "⚾️" },
      { gridId: "MLB #63", href: "/mlb/63", emoji: "⚾️" },
      { gridId: "MLB #62", href: "/mlb/62", emoji: "⚾️" },
      { gridId: "MLB #61", href: "/mlb/61", emoji: "⚾️" },
      { gridId: "MLB #60", href: "/mlb/60", emoji: "⚾️" },
      { gridId: "MLB #59", href: "/mlb/59", emoji: "⚾️" },
      { gridId: "MLB #58", href: "/mlb/58", emoji: "⚾️" },
      { gridId: "MLB #57", href: "/mlb/57", emoji: "⚾️" },
      { gridId: "MLB #56", href: "/mlb/56", emoji: "⚾️" },

      { gridId: "MLB #55", href: "/mlb/55", emoji: "⚾️" },
      { gridId: "MLB #54", href: "/mlb/54", emoji: "⚾️" },
      { gridId: "MLB #53", href: "/mlb/53", emoji: "⚾️" },
      { gridId: "MLB #52", href: "/mlb/52", emoji: "⚾️" },
      { gridId: "MLB #51", href: "/mlb/51", emoji: "⚾️" },

      { gridId: "MLB #50", href: "/mlb/50", emoji: "⚾️" },
      { gridId: "MLB #49", href: "/mlb/49", emoji: "⚾️" },
      { gridId: "MLB #48", href: "/mlb/48", emoji: "⚾️" },
      { gridId: "MLB #47", href: "/mlb/47", emoji: "⚾️" },
      { gridId: "MLB #46", href: "/mlb/46", emoji: "⚾️" },
      { gridId: "MLB #45", href: "/mlb/45", emoji: "⚾️" },
      { gridId: "MLB #44", href: "/mlb/44", emoji: "⚾️" },

      { gridId: "MLB #43", href: "/mlb/43", emoji: "⚾️" },
      { gridId: "MLB #42", href: "/mlb/42", emoji: "⚾️" },
      { gridId: "MLB #41", href: "/mlb/41", emoji: "⚾️" },
      { gridId: "MLB #40", href: "/mlb/40", emoji: "⚾️" },
      { gridId: "MLB #39", href: "/mlb/39", emoji: "⚾️" },
      { gridId: "MLB #38", href: "/mlb/38", emoji: "⚾️" },
      { gridId: "MLB #37", href: "/mlb/37", emoji: "⚾️" },
      { gridId: "MLB #36", href: "/mlb/36", emoji: "⚾️" },

      { gridId: "MLB #35", href: "/mlb/35", emoji: "⚾️" },

      { gridId: "MLB #34", href: "/mlb/34", emoji: "⚾️" },

      { gridId: "MLB #33", href: "/mlb/33", emoji: "⚾️" },

      { gridId: "MLB #32", href: "/mlb/32", emoji: "⚾️" },

      { gridId: "MLB #31", href: "/mlb/31", emoji: "⚾️" },

      { gridId: "MLB #30", href: "/mlb/30", emoji: "⚾️" },
      { gridId: "MLB #29", href: "/mlb/29", emoji: "⚾️" },
      { gridId: "MLB #28", href: "/mlb/28", emoji: "⚾️" },
      { gridId: "MLB #27", href: "/mlb/27", emoji: "⚾️" },
      { gridId: "MLB #26", href: "/mlb/26", emoji: "⚾️" },
      { gridId: "MLB #25", href: "/mlb/25", emoji: "⚾️" },
      { gridId: "MLB #24", href: "/mlb/24", emoji: "⚾️" },
      { gridId: "MLB #23", href: "/mlb/23", emoji: "⚾️" },
      { gridId: "MLB #22", href: "/mlb/22", emoji: "⚾️" },
      { gridId: "MLB #21", href: "/mlb/21", emoji: "⚾️" },
      { gridId: "FBB #2", href: "/fbb", emoji: "⚾️" },
      { gridId: "MLB #20", href: "/mlb/20", emoji: "⚾️" },
      { gridId: "MLB #19", href: "/mlb/19", emoji: "⚾️" },
      { gridId: "MLB #18", href: "/mlb/18", emoji: "⚾️" },
      { gridId: "MLB #17", href: "/mlb/17", emoji: "⚾️" },
      { gridId: "MLB #16", href: "/mlb/16", emoji: "⚾️" },
      { gridId: "MLB #15", href: "/mlb/15", emoji: "⚾️" },
      { gridId: "MLB #14", href: "/mlb/14", emoji: "⚾️" },
      { gridId: "MLB #13", href: "/mlb/13", emoji: "⚾️" },
      { gridId: "MLB #12", href: "/mlb/12", emoji: "⚾️" },
      { gridId: "MLB #11", href: "/mlb/11", emoji: "⚾️" },
      { gridId: "MLB #10", href: "/mlb/10", emoji: "⚾️" },
      { gridId: "MLB #9", href: "/mlb/9", emoji: "⚾️" },
      { gridId: "MLB #8", href: "/mlb/8", emoji: "⚾️" },
      { gridId: "MLB #7", href: "/mlb/7", emoji: "⚾️" },
      { gridId: "MLB #6", href: "/mlb/6", emoji: "⚾️" },
      { gridId: "MLB #5", href: "/mlb/5", emoji: "⚾️" },
      { gridId: "MLB #4", href: "/mlb/4", emoji: "⚾️" },
      { gridId: "MLB #3", href: "/mlb/3", emoji: "⚾️" },
      { gridId: "MLB #2", href: "/mlb/2", emoji: "⚾️" },
      { gridId: "MLB #1", href: "/mlb/1", emoji: "⚾️" },

      // ... other grid history data
    ],
  
  },
  {
    id: "100",
    emoji: "🌍",
    name: "Geography",
    path: "/geography",
    gridHistory: [], // Will be populated dynamically from start date through today
    fetchDynamicHistory: true, // Flag to indicate dynamic date-based fetching
    sportIdForAPI: 100, // Sport ID for the new /game/sport/{id}/date endpoint
  },
  {
    id: "60",
   emoji: "⚽️",
    name: "Trivia",
    path: "/Trivia",
   gridHistory: [
   { gridId: "Prime #1", href: "/prime", emoji: "🏈" },
   
   ], },
   {
    id: "80",
   emoji: "🏈🧠",
    name: "Trivia",
    path: "/nfl/trivia",
   gridHistory: [
   { gridId: "Prime #1", href: "/prime", emoji: "🏈" },
   
   ],
   },{
    id: "85",
   emoji: "⚾️",
    name: "Connections",
    path: "/mlb/connections",
   gridHistory: [
   { gridId: "Prime #1", href: "/prime", emoji: "🏈" },
   
   ], },{
    id: "90",
   emoji: "⚾️🧠",
    name: "Trivia",
    path: "/mlb/trivia",
   gridHistory: [
   { gridId: "Prime #1", href: "/prime", emoji: "🏈" },
   
   ],
   },
   
   {
    id: "95",
   emoji: "💻",
    name: "AI Tools",
    path: "/AI",
   gridHistory: [
   { gridId: "Prime #1", href: "/prime", emoji: "🏈" },
   
   ], },{
    id: "27",
   emoji: "🏒",
    name: "Connections",
    path: "/Nhl/connections",
   gridHistory: [
   { gridId: "Prime #1", href: "/prime", emoji: "🏈" },
   
   ], },

   {
    id: "110",
   emoji: "🏈",
    name: "Connections",
    path: "/nfl/connections",
   gridHistory: [
   { gridId: "Prime #1", href: "/prime", emoji: "🏈" },
   
   ], },   {
    id: "100",
   emoji: "🏀",
    name: "Connections",
    path: "/nba/connections",
   gridHistory: [
   { gridId: "Prime #1", href: "/prime", emoji: "🏈" },
   
   ], },

  {
    id: "16",
    emoji: "⛳",
    name: "PGA TOUR",
    path: "/pga",
    gridHistory: [
      { gridId: "PGA TOUR #9", href: "/pga/9", emoji: "⛳" },

      { gridId: "PGA TOUR #8", href: "/pga/8", emoji: "⛳" },

      { gridId: "PGA TOUR #7", href: "/pga/7", emoji: "⛳" },

      { gridId: "PGA TOUR #6", href: "/pga/6", emoji: "⛳" },

      { gridId: "PGA TOUR #5", href: "/pga/5", emoji: "⛳" },
      { gridId: "PGA TOUR #4", href: "/pga/4", emoji: "⛳" },

      { gridId: "PGA TOUR #3", href: "/pga/3", emoji: "⛳" },

      { gridId: "PGA TOUR #2", href: "/pga/2", emoji: "⛳" },

      { gridId: "PGA TOUR #1", href: "/pga/1", emoji: "⛳" },
    ],
  },
  {
    id: "13",
    emoji: "📺",
    name: "TV",
    path: "/tv",
    gridHistory: [
      { gridId: "TV #5", href: "/tv/5", emoji: "📺" },

      { gridId: "TV #4", href: "/tv/4", emoji: "📺" },
      { gridId: "TV #3", href: "/tv/3", emoji: "📺" },
      { gridId: "TV #2", href: "/tv/2", emoji: "📺" },

      { gridId: "TV #1", href: "/tv/1", emoji: "📺" },
      // ... other grid history data
    ],
  },
  {
    id: "10",
    emoji: "🏈",
    name: "CFB",
    path: "/cfb",
    gridHistory: [
      { gridId: "CFB #9", href: "/cfb/9", emoji: "🏈" },

      { gridId: "CFB #8", href: "/cfb/8", emoji: "🏈" },

      { gridId: "CFB #7", href: "/cfb/7", emoji: "🏈" },
      { gridId: "CFB #6", href: "/cfb/6", emoji: "🏈" },
      { gridId: "CFB #5", href: "/cfb/5", emoji: "🏈" },
      { gridId: "CFB #4", href: "/cfb/4", emoji: "🏈" },
      { gridId: "CFB #3", href: "/cfb/3", emoji: "🏈" },
      { gridId: "CFB #2", href: "/cfb/2", emoji: "🏈" },
      { gridId: "CFB #1", href: "/cfb/1", emoji: "🏈" },
      // ... other grid history data
    ],
  },
  {
    id: "11",
    emoji: "🏀",
    name: "CBB",
    path: "/cbb",
    gridHistory: [
      { gridId: "CBB #2", href: "/cbb/2", emoji: "🏀" },

      { gridId: "CBB #1", href: "/cbb/1", emoji: "🏀" },
      // ... other grid history data
    ],
  },

  {
    id: "17",
    emoji: "⚽️",
    name: "Bonus",
    path: "/futbol",
    gridHistory: [
      { gridId: "Bonus #5", href: "/futbol/5", emoji: "⚽️" },
      { gridId: "Bonus #4", href: "/futbol/4", emoji: "⚽️" },
      { gridId: "Sky #1", href: "/futbol/sky", emoji: "⚽️" },
      { gridId: "PL #3", href: "/futbol/3", emoji: "⚽️" },
      { gridId: "PL #2", href: "/futbol/2", emoji: "⚽️" },
      { gridId: "PL #1", href: "/futbol/1", emoji: "⚽️" },
      // ... other grid history data
    ],
  },
  {
    id: "6",
    emoji: "⛳️",
    name: "PGA",
    path: "/golf",
    gridHistory: [
      
      { gridId: "PGA #8", href: "/golf/8", emoji: "⛳️" },
      { gridId: "PGA #7", href: "/golf/7", emoji: "⛳️" },
      { gridId: "PGA #6", href: "/golf/6", emoji: "⛳️" },
      { gridId: "PGA #5", href: "/golf/5", emoji: "⛳️" },
      { gridId: "PGA #4", href: "/golf/4", emoji: "⛳️" },
      { gridId: "PGA #3", href: "/golf/3", emoji: "⛳️" },
      { gridId: "PGA #2", href: "/golf/2", emoji: "⛳️" },
      { gridId: "PGA #1", href: "/golf/1", emoji: "⛳️" },
      // ... other grid history data
    ],
  },
  {
    id: "9",
    emoji: "🏎",
    name: "F1",
    path: "/racing",
    gridHistory: [
      { gridId: "F1 #6", href: "/racing/6", emoji: "🏎" },
      { gridId: "F1 #5", href: "/racing/5", emoji: "🏎" },
      { gridId: "F1 #4", href: "/racing/4", emoji: "🏎" },
      { gridId: "F1 #3", href: "/racing/3", emoji: "🏎" },
      { gridId: "F1 #2", href: "/racing/2", emoji: "🏎" },
      { gridId: "F1 #1", href: "/racing/1", emoji: "🏎" },
    ],
  },
  {
    id: "20",
    emoji: "🏈",
    name: "Bonus",
    path: "/cbs",
    gridHistory: [
      { gridId: "CBS #1", href: "/cbs/1", emoji: "🏈" },
      { gridId: "PFT #1", href: "/pft/1", emoji: "🏈" },

      // ... other grid history data
    ],
  },
];

export default sports;
